/* 日本語 — Japanese */
const ja = {
  nav: {
    home: 'ホーム',
    imageConverter: '画像変換',
    imageCompressor: '画像圧縮',
    otherTools: 'その他のツール',
    resizeImage: '画像リサイズ',
    cropImage: '画像トリミング',
    photoEditor: 'フォトエディタ',
    removeBackground: '背景除去',
    watermarkImage: '透かし追加',
    qrCodeGenerator: 'QRコードジェネレーター',
    qrCodeScanner: 'QRコードスキャナー',
    aboutUs: '私たちについて',
    faceBlur: '顔ぼかし',
  },
  hero: {
    heading: '必要な画像ツールがすべて揃っています',
    subheading: '画像の変換・圧縮・リサイズ・トリミング・編集・変換を無料でオンライン処理。すべてブラウザ内で処理されるため、高速・プライベート・安全です。',
  },
  tools: {
    compressImage: { title: '画像を圧縮', desc: 'JPG、PNG、SVG、GIFを圧縮してスペースを節約し、品質を維持します。' },
    resizeImage: { title: '画像をリサイズ', desc: 'JPG、PNG、SVG、GIF画像をパーセントまたはピクセルでサイズ変更します。' },
    cropImage: { title: '画像をトリミング', desc: 'JPG、PNGまたはGIFを簡単にトリミング。ピクセルで矩形を定義するかビジュアルエディタを使用します。' },
    convertToJpg: { title: 'JPGに変換', desc: 'PNG、GIF、TIF、PSD、SVG、WEBP、HEIC、RAW形式の画像を一括でJPGに変換します。' },
    convertFromJpg: { title: 'JPGから変換', desc: 'JPG画像をPNGやGIFに変換。複数のJPGを選んでアニメーションGIFを作成できます！' },
    qrCodeGenerator: { title: 'QRコードジェネレーター', desc: 'URL、テキスト、WiFi、連絡先、メール、地図用のカスタムQRコードを生成。スタイル、色、ロゴをカスタマイズ。' },
    qrCodeScanner: { title: 'QRコードスキャナー', desc: 'カメラや画像アップロードでQRコードを即座にスキャン。URL、テキスト、WiFi、連絡先などを検出。' },
    blurFace: { title: '顔ぼかし', desc: 'プライバシー保護のために画像の顔を自動検出してぼかします。ぼかし強度・形状・絵文字オーバーレイを調整可能。' },
    removeBackground: { title: '背景除去', desc: '高精度で画像の背景を素早く除去。オブジェクトを即座に検出して背景を切り取ります。' },
    watermarkImage: { title: '透かしを追加', desc: '数秒で画像にテキストや画像スタンプを追加。フォント、透明度、位置を選択できます。' },
  },
  whyChoose: {
    label: '選ばれる理由',
    heading: 'より賢い画像編集の方法',
    subheading: '世界中の何千ものクリエイター、デザイナー、開発者に信頼されています。photremium.comが画像編集の定番である理由をご紹介します。',
    reasons: {
      fast: { title: '超高速処理', desc: 'すべての処理はブラウザ内で直接行われます。外部サーバーへのアップロード不要 — 結果はミリ秒で表示されます。' },
      private: { title: '100%プライベート＆安全', desc: 'ファイルはデバイスから外に出ることはありません。画像を保存・共有・アクセスすることは一切ありません。完全なプライバシーを保証します。' },
      noLimits: { title: '制限なし・登録不要', desc: 'すべてのツールを何度でも使用できます — 完全無料。アカウント不要、透かしなし、隠れた料金なし。' },
      quality: { title: 'プロフェッショナル品質', desc: 'アルゴリズムはスタジオグレードの結果を提供します。品質の低下なく圧縮し、完璧な忠実度で変換します。' },
      batch: { title: 'バッチ処理', desc: '複数のファイルを一度に処理。画像フォルダ全体を一つの操作で変換・圧縮・リサイズできます。' },
      everywhere: { title: 'どこでも動作', desc: 'デスクトップ、タブレット、スマートフォンで完全対応のレスポンシブデザイン。ダウンロードやインストール不要。' },
    },
    stats: {
      imagesProcessed: '処理された画像',
      countriesServed: '対応国',
      uptime: '稼働時間',
      freeTools: '無料ツール',
    },
  },
  footer: {
    tagline: '無料オンライン画像ツール — 数秒で画像を変換・圧縮・リサイズ・トリミング・編集。登録不要。',
    imageTools: '画像ツール',
    moreTools: 'その他のツール',
    company: '会社情報',
    contact: 'お問い合わせ',
    allRightsReserved: '全著作権所有。',
    privacyPolicy: 'プライバシーポリシー',
    termsOfService: '利用規約',
  },
  faq: {
    badge: 'よくある質問',
    heading: 'よくある質問',
    subheading: 'このツールに関するよくある質問への回答です。',
    stillHaveQuestions: 'まだ質問がありますか？お気軽にどうぞ！',
    reachOut: 'チームに連絡する',
    questionHeader: '質問',
  },

  contactForm: {
    badge: 'お問い合わせ',
    title: 'お問い合わせ',
    subtitle: 'お気軽にメッセージをお送りください！',
    nameLabel: '名前',
    namePlaceholder: 'フルネーム',
    emailLabel: 'メールアドレス',
    emailPlaceholder: 'you@example.com',
    subjectLabel: '件名',
    subjectPlaceholder: 'どのような内容ですか？',
    messageLabel: 'メッセージ',
    messagePlaceholder: 'こちらにメッセージをお書きください…',
    errName: '名前を入力してください',
    errEmail: 'メールアドレスを入力してください',
    errEmailInvalid: '有効なメールアドレスを入力してください',
    errSubject: '件名を入力してください',
    errMessage: 'メッセージを入力してください',
    sending: '送信中…',
    send: '送信する',
    successTitle: '送信完了!',
    successMsg: 'お問い合わせいただきありがとうございます。すぐにご連絡いたします。',
    sendAnother: '別のメッセージを送る',
    sendError: 'エラーが発生しました。もう一度お試しください。',
  },

  about: {
    label: '私たちについて',
    heading: 'クリエイターのために、クリエイターが作った',
    subheading: '強力な画像ツールは無料で、高速で、誰もが利用できるべきだと私たちは信じています。',
    missionTitle: '私たちのミッション',
    missionText: 'photremium.comはシンプルな目標で作られました：ウェブ上で最も直感的で、最速で、最もプライベートな画像編集体験を提供すること。すべてをブラウザ内で処理するため、ファイルはデバイスから出ることはありません。アカウント不要、制限なし、妥協なし。',
    privacyTitle: 'プライバシーファースト',
    privacyText: 'リモートサーバーで画像をアップロード・保存・処理することは一切ありません。すべてはデバイス上に留まります。',
    techTitle: '最新技術',
    techText: 'WebAssembly、Canvas API、最新のReactなどの最先端ウェブ技術で構築されています。',
    communityTitle: 'コミュニティ主導',
    communityText: '構築するすべての機能は実際のユーザーフィードバックに基づいています。皆様のご提案がロードマップを形成します。',
    globalTitle: 'グローバルな展開',
    globalText: '120以上の国のクリエイターに利用されています。超高速CDN配信で複数言語対応。',
  },
  seo: {
    homeTitle: 'photremium.com — 無料オンライン画像変換・圧縮・編集ツール',
    homeDesc: '画像をオンラインで無料に変換・圧縮・リサイズ・トリミング・編集。高速・プライベート・安全 — すべてブラウザで処理。',
    homeKeywords: '画像変換, 画像圧縮, リサイズ, トリミング, フォトエディタ, 無料画像ツール',
    aboutTitle: 'photremium.comについて — ミッションとストーリー',
    aboutDesc: 'photremium.comについてご紹介。数百万人に信頼される無料オンライン画像ツールキット。',
    aboutKeywords: 'photremium.com について, 画像ツール, 無料画像エディタ',
  },
        privacyPolicyPage: {
    seo: {
      title: 'プライバシー ポリシー — Photremium |サーバーへのアップロードなし、データストレージなし',
      description: 'Photremium のプライバシー ポリシーでは、当社がお客様のプライバシーをどのように保護するかについて説明しています。すべての画像処理は 100% ブラウザ内で行われます。サーバーへのファイルのアップロード、個人データの収集、追跡はありません。',
      ogTitle: 'プライバシー ポリシー — Photremium |アップロードなし、ストレージゼロ',
      ogDescription: 'ファイルはデバイス上に残ります。 Photremium は、サーバーへの接続、データの保存、追跡を行わずに、ブラウザ内ですべての画像をローカルに処理します。',
      twitterTitle: 'プライバシーポリシー — Photremium',
      twitterDescription: '100% ブラウザベースの画像ツール。アップロード、ストレージ、追跡はありません。当社のプライバシーポリシー全文をお読みください。',
      schemaName: 'プライバシーポリシー - フォトレミアム',
      schemaDescription: 'Photremium プライバシー ポリシー - サーバーへのアップロードなし、データの保存なし、100% ブラウザ内画像処理。'
    },
    hero: {
      badge: 'プライバシーポリシー',
      titlePrefix: 'あなたのプライバシーは私たちのものです',
      titleHighlight: '最優先事項',
      subPrefix: 'photremium.com は単純な原則に基づいて構築されています —',
      subStrong: 'ファイルがデバイスから離れることはありません',
      subSuffix: 'このサイトのすべての画像ツールはブラウザ内で完全に実行されます。アップロードはありません。雲はありません。妥協はありません。',
      effectiveLabel: '効果的',
      lastUpdatedLabel: '最終更新日',
      worldwideLabel: '世界中に適用されます'
    },
    trustCards: [
      {
        title: 'サーバーアップロードなし',
        desc: 'ファイルがデバイスの外に出ることはありません。すべての処理は 100% ブラウザ内で行われます。'
      },
      {
        title: 'ゼロデータストレージ',
        desc: '私たちはあなた、あなたの画像、あなたの活動について何も保存しません。'
      },
      {
        title: '追跡なし',
        desc: '行動追跡、フィンガープリンティング、プロファイリングはありません。'
      },
      {
        title: 'GDPR対応',
        desc: '世界的なプライバシー規制を尊重するためにゼロから設計されています。'
      }
    ],
    contentsTitle: 'コンテンツ',
    toc: {
      overview: '概要',
      'no-upload': 'サーバー処理なし',
      'data-collect': '当社が収集するデータ',
      cookies: 'クッキーとストレージ',
      'third-party': 'サードパーティのサービス',
      analytics: '分析',
      children: '子供のプライバシー',
      rights: 'あなたの権利',
      security: '安全',
      changes: 'ポリシーの変更',
      contact: 'お問い合わせ'
    },
    sections: {
      overview: {
        title: '1. 概要',
        subtitle: 'このポリシーの対象となるもの',
        p1Prefix: 'このプライバシー ポリシーでは、次の方法について説明します。',
        p1Middle: '(「私たち」、「私たち」、または「私たちの」) は、より正確には、',
        p1Italic: '扱いません',
        p1Suffix: '弊社の無料オンライン画像ツールを使用する際の個人情報',
        p2: 'ファイルをリモート サーバーに送信して処理する従来の Web アプリケーションとは異なり、photremium.com は最新のブラウザ API (Canvas API、WebAssembly、WebWorkers) を使用して、デバイス上でローカルにすべての操作を実行します。その結果、データ送信もストレージもリスクもありません。',
        calloutLabel: '平易な英語の要約:',
        calloutText: '私たちはあなたの画像を見ることはできませんし、見たくありません。そして私たちのテクノロジーは、私たちが決して見ることができないように特別に設計されています。'
      },
      noUpload: {
        title: '2. サーバー処理は一切不要',
        subtitle: '私たちのツールが実際にどのように機能するか',
        introPrefix: 'photremium.com のすべてのツール (画像コンバーター、圧縮ツール、サイズ変更ツール、背景除去ツール、顔ぼかしツール、透かしツール、切り抜きツール、QR コード ツール) がファイルを処理します。',
        introStrong: '100% ウェブブラウザ内で',
        introSuffix: 'クライアント側の JavaScript と WebAssembly を使用します。',
        points: [
          {
            label: 'ファイルのアップロードは行われません。',
            text: 'ファイルを選択すると、そのファイルはブラウザの File API によって読み取られ、メモリ内で処理されます。ネットワーク経由で送信されることはありません。'
          },
          {
            label: '画像を受信するサーバーはありません。',
            text: '当社の CDN は、アプリの実行に必要な HTML、CSS、JavaScript アセットのみを提供し、ファイルは提供しません。'
          },
          {
            label: '一時保管は行っておりません。',
            text: '処理された結果はブラウザのメモリ内にのみ存在し、ページを閉じるかページから移動すると解放されます。'
          },
          {
            label: 'オフラインでも動作します。',
            text: 'ほとんどのツールは、最初のページの読み込み後、インターネット接続がなくても機能し続けます。これは、サーバーが関与していないことをさらに証明しています。'
          }
        ],
        callout: 'これは自分でも確認できます。ブラウザの開発者ツールの [ネットワーク] タブを開き、画像を選択して、ファイル データが外部サーバーに送信されていないことを確認します。'
      },
      dataCollect: {
        title: '3. 当社が収集するデータ (および収集しないデータ)',
        subtitle: 'データ慣行に関する完全な透明性',
        headers: {
          type: 'データ型',
          collected: '集めた?',
          whereWhy: 'どこで/なぜ'
        },
        rows: [
          {
            type: 'あなたの画像/ファイル',
            badge: '一度もない',
            variant: '緑',
            showX: true,
            whereWhy: 'ブラウザ内で完全に処理され、送信されることはありません'
          },
          {
            type: '名前/メールアドレス',
            badge: '一度もない',
            variant: '緑',
            showX: true,
            whereWhy: 'ツールを使用するのにアカウントやサインアップは必要ありません'
          },
          {
            type: 'IPアドレス',
            badge: '最小限',
            variant: 'グレー',
            showX: false,
            whereWhy: '標準 Web サーバーのログは 30 日以内に保持され、ID に関連付けられません'
          },
          {
            type: 'ブラウザ・OSの種類',
            badge: '最小限',
            variant: 'グレー',
            showX: false,
            whereWhy: 'ブラウザによって自動的に送信されます。互換性のためだけに使用されます'
          },
          {
            type: '訪問したページ/クリック数',
            badge: '集約された',
            variant: '青',
            showX: false,
            whereWhy: '匿名分析のみ (個人の特定は不可)'
          },
          {
            type: '言語の好み',
            badge: 'ローカルのみ',
            variant: '青',
            showX: false,
            whereWhy: 'デバイスのローカルストレージに保存されます - 私たちに送信されることはありません'
          },
          {
            type: '支払い/財務データ',
            badge: '一度もない',
            variant: '緑',
            showX: true,
            whereWhy: 'photremium.com は完全に無料で、支払いは必要ありません'
          }
        ]
      },
      cookies: {
        title: '4. Cookie とローカル ストレージ',
        subtitle: 'デバイスに保存されるもの',
        intro: 'photremium.com は、広告 Cookie、クロスサイト トラッキング Cookie、サードパーティ Cookie を使用しません。当社が使用するブラウザ ストレージは、サイトの重要な機能にのみ使用されます。',
        points: [
          {
            label: '言語の好み',
            text: 'localStorage に保存されるため、次の訪問までにサイトが優先言語を記憶します。当社のサーバーに送信されることはありません。'
          },
          {
            label: 'テーマ/UIの設定',
            text: '表示設定を設定すると、その設定はデバイス上にのみローカルに保存されます。'
          },
          {
            label: 'セッションクッキーはありません。',
            text: 'photremium.com にはログイン システムがないため、セッション ID Cookie が書き込まれることはありません。'
          }
        ],
        callout: 'すべての photremium.com ローカル ストレージは、ブラウザの設定でいつでもクリアできます ([設定] -> [プライバシー] -> [閲覧データのクリア] -> [キャッシュされたデータと Cookie])。これを行っても、ツールを使用する能力には影響しません。'
      },
      thirdParty: {
        title: '5. サードパーティサービス',
        subtitle: '当社が使用する外部サービスとその理由',
        intro: 'photremium.com は、インフラストラクチャとパフォーマンスのみを目的として、信頼できるサードパーティ サービスの最小限のセットを使用します。これらのサービスはいずれも、お客様の画像や個人を特定できる情報を受け取りません。',
        headers: {
          service: 'サービス',
          purpose: '目的',
          dataShared: '共有されるデータ',
          privacyPolicy: 'プライバシーポリシー'
        },
        rows: [
          {
            service: 'クラウドフレアページ',
            purpose: 'サイトアセットのホスティングと CDN 配信',
            dataShared: 'IPアドレス、HTTPヘッダー（標準）',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: '素晴らしいフォント',
            purpose: 'CDN からロードされたアイコン フォント',
            dataShared: 'IPアドレス（CSSリクエストのみ）',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Google フォント',
            purpose: '書体の読み込み (該当する場合)',
            dataShared: 'IPアドレス（フォントリクエストのみ）',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: '当社は、お客様のデータを広告主、データ ブローカー、または上記のインフラストラクチャ プロバイダー以外の第三者と共有することはありません。'
      },
      analytics: {
        title: '6. 分析',
        subtitle: 'プライバシーを尊重した使用状況データを集約',
        introPrefix: 'どのツールが人気があるのか​​、またサイトをどのように改善するのかを理解するために、当社は以下の情報を収集する場合があります。',
        introStrong: '集約され、匿名化された',
        introSuffix: '次のような使用統計。',
        points: [
          'ツールごとのページビュー数 (ユーザー識別なし)',
          '参照元 (例: Google 検索、直接リンク) - 個人データなし',
          '国レベルの地理データ (都市や正確な位置ではない)',
          '互換性分析用のブラウザ/デバイスの種類'
        ],
        calloutLabel: 'データがあなた個人にリンクされることはありません。',
        calloutText: 'Google Analytics や Meta Pixel は使用しません。当社が使用する分析はすべて、プライバシー最優先のツールです (Plausible など)。'
      },
      children: {
        title: '7. 子供のプライバシー',
        subtitle: 'COPPA と子供の安全に関するコンプライアンス',
        p1: 'photremium.com は、13 歳 (GDPR に基づく欧州連合では 16 歳) 未満の子供から意図的に個人情報を収集することはありません。当社はいかなるユーザーからも個人データを収集しないため、若いユーザーに対して特別なことは何もありません。このサイトは誰にとっても等しく安全です。',
        p2Prefix: 'お子様が何らかの形で弊社のお問い合わせフォームを通じて個人情報を送信したと思われる場合は、直ちに弊社までご連絡ください。',
        p2Suffix: '速やかに削除させていただきます。'
      },
      rights: {
        title: '8. お客様の権利',
        subtitle: 'GDPR、CCPA、およびグローバルなプライバシー権',
        intro: 'photremium.com は個人を特定できる情報を収集しないため、ほとんどのデータ主体の権利は簡単に適用されます。アクセス、修正、または削除する必要のあるユーザーに関するデータはありません。それにもかかわらず、私たちは以下の権利を十分に認め、尊重します。',
        points: [
          {
            label: 'アクセスする権利',
            text: 'お客様は、当社がお客様に関して保持しているデータのコピーを要求することができます。 (匿名化されたログ以外には何もありません。)'
          },
          {
            label: '訂正する権利',
            text: '不正確な個人データの修正を要求することができます。'
          },
          {
            label: '消去する権利（「忘れられる権利」）',
            text: 'お客様は、当社が保有する個人データの削除を要求することができます (GDPR 第 17 条、CCPA)。'
          },
          {
            label: '反対/オプトアウトする権利',
            text: 'ブラウザレベルのオプトアウトまたは広告ブロック ツールを使用して、今後の分析収集をオプトアウトできます。'
          },
          {
            label: 'データポータビリティの権利',
            text: 'すべての作業はデバイスに直接ダウンロードされます。エクスポート リクエストは必要ありません。'
          }
        ],
        callout: 'これらの権利は、管轄区域に関係なく、世界中のすべてのユーザーに適用されます。当社は最高基準 (GDPR) をベースラインとして適用します。'
      },
      security: {
        title: '9. セキュリティ',
        subtitle: 'あなたのエクスペリエンスを保護する方法',
        intro: '最も安全なデータは、決して収集されないデータです。 photremium.com のクライアント側アーキテクチャにより、ファイルは当社のサーバー上に存在しないため、サーバー侵害によってファイルが公開されることはありません。追加のセキュリティ対策には次のものが含まれます。',
        points: [
          {
            label: 'HTTPS の強制',
            text: 'ブラウザと CDN の間のすべてのトラフィックは、HSTS を使用した TLS 1.2+ を介して暗号化されます。'
          },
          {
            label: 'コンテンツ セキュリティ ポリシー (CSP)',
            text: '厳密なヘッダーにより、クロスサイト スクリプティングとインライン スクリプト インジェクションが防止されます。'
          },
          {
            label: '定期的な依存関係の監査',
            text: '私たちは npm パッケージを定期的に監査して更新し、既知の脆弱性にパッチを当てます。'
          }
        ],
        disclosurePrefix: '責任ある開示',
        disclosureTextPrefix: 'セキュリティ上の問題が見つかりましたか?メールでご連絡ください',
        disclosureTextSuffix: '48時間以内に返信させていただきます。'
      },
      changes: {
        title: '10. 本ポリシーの変更',
        subtitle: 'ポリシー更新の処理方法',
        intro: '当社は、当社の慣行、ツール、または法的要件の変更を反映するために、このプライバシー ポリシーを随時更新することがあります。実行するとき:',
        points: [
          {
            label: '「最終更新日」',
            text: 'このページの上部にある日付が変更されます。'
          },
          {
            label: '素材の変更',
            text: '少なくとも 30 日間、ホームページ上の目立つ通知を通じて通知されます。'
          },
          {
            label: '以前のバージョン',
            text: 'このポリシーはアーカイブされ、リクエストに応じて利用可能になります。'
          }
        ],
        outro: '変更が公開された後も photremium.com を継続的に使用すると、更新されたポリシーに同意したことになります。このページを定期的に確認することをお勧めします。'
      },
      contact: {
        title: '11. 連絡先とデータのリクエスト',
        subtitle: 'プライバシーについて問い合わせる',
        p1Prefix: 'このプライバシーポリシーに関するご質問、懸念事項、または正式なデータリクエストについては、当社までご連絡ください。当社は、プライバシーに関するすべてのお問い合わせに以内に回答することを目指しています。',
        p1Strong: '5営業日'
      }
    },
    footer: {
      privacyQuestionsTitle: 'プライバシーに関する質問がありますか?',
      privacyQuestionsDesc: 'プライバシーに関する質問、データリクエスト、または懸念事項を当社に送信していただければ、すぐに対応させていただきます。',
      versionHistoryTitle: 'バージョン履歴',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
/* ————— Common / shared UI strings ————— */
  common: {
    new: '新着！',
    download: 'ダウンロード',
    downloadAll: 'すべてダウンロード',
    downloadAs: 'ダウンロード形式:',
    zip: 'ZIP',
    separate: '個別',
    upload: 'アップロード',
    dragDrop: 'ここに画像をドラッグ＆ドロップ、またはクリックして参照',
    remove: '削除',
    reset: 'リセット',
    apply: '適用',
    cancel: 'キャンセル',
    clear: 'クリア',
    close: '閉じる',
    save: '保存',
    processing: '処理中...',
    noFiles: 'ファイルが選択されていません',
    selectFiles: 'ファイルを選択',
    or: 'または',
    browseFiles: 'ファイルを参照',
    dropHere: 'ここに画像をドロップ',
    chooseFiles: 'ファイルを選択',
    pasteHint: '画像を貼り付けることもできます',
    quality: '品質',
    width: '幅',
    height: '高さ',
    format: 'フォーマット',
    compression: '圧縮',
    preview: 'プレビュー',
    original: 'オリジナル',
    result: '結果',
    before: '変換前',
    after: '変換後',
    startOver: 'やり直す',
    startOverConfirm: 'すべての画像を削除してやり直しますか？',
    addMoreImages: '画像を追加',
    addImage: '画像を追加',
    images: '画像',
    totalSize: '合計サイズ',
    size: 'サイズ',
    type: 'タイプ',
    unsavedEdits: '未保存の編集があります。このページを離れますか？',
    compareSlider: '比較スライダー',
    toggleToolsPanel: 'ツールパネルの表示/非表示',
    closePanel: 'パネルを閉じる',
    zoomIn: 'ズームイン',
    zoomOut: 'ズームアウト',
    fit: 'フィット',
    none: 'なし',
  },
  compressor: {
    seo: {
      uploadTitle: '画像圧縮 — JPG、PNG、SVG、GIFを無料で圧縮 | photremium.com',
      uploadDesc: 'JPG、PNG、SVG、GIF画像をオンラインで無料圧縮。視覚的品質を維持しながらファイルサイズを最大80%削減。登録不要。',
      uploadKeywords: '画像圧縮, JPG圧縮, PNG圧縮, 画像サイズ削減, 画像最適化',
      workspaceTitle: '画像を圧縮中 — photremium.com画像圧縮',
      workspaceDesc: '圧縮レベルを調整して最適化された画像をダウンロード。',
      workspaceKeywords: '画像圧縮, バッチ圧縮',
    },
    title: '画像圧縮',
    desc: 'JPG、PNG＆GIF画像を最大80%圧縮。高速・プライベート — ブラウザ内で完全動作。',
    toCompress: '圧縮する',
    compressionForAll: 'すべての画像の圧縮設定',
    summary: '概要',
    originalSize: '元のサイズ',
    compressed: '圧縮後',
    saved: '節約',
    compressionLabel: '圧縮:',
    compressing: '圧縮中…',
    compressDownload: '圧縮してダウンロード',
    lowQualityWarning: '圧縮率が高いと、画像の鮮明さが大きく低下する場合があります。',
    blog: {
      tocTitle: '目次',
      title: '画像圧縮ブログ',
      formatsIntro: '当ツールはすべての画像形式をサポートしているため、あらゆる画像をスムーズに圧縮できます。対応形式の一覧は以下のとおりです。',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. 画像圧縮ツールとは？',
          paragraphs: [
            '画像圧縮ツールは、見た目の品質をできるだけ保ちながら画像ファイルのサイズを小さくするソフトウェアまたはオンラインサービスです。ただし、圧縮しすぎると品質低下が目立つ場合があります。',
          ],
          listTitle: '種類：',
          bullets: [
            '非可逆圧縮：画像データの一部を削減してサイズを小さくします。品質は下がることがありますが、軽度なら人の目で気づきにくいことが多いです。',
            '可逆圧縮：画像の見た目の品質を損なわずにファイルサイズを小さくします。',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. なぜ当ツールを選ぶのか？',
          bullets: [
            'AI 搭載の画像圧縮ツールが、あらゆるデバイスで安定して高品質な結果を提供します。',
            '複数画像（100枚以上でも）をワンクリックで一括圧縮できます。',
            '画像をサーバーへアップロードする必要はありません。すべてブラウザ内でローカル処理されます。',
            'この画像圧縮ツールはずっと無料です。友だちへの共有も自由です。',
            '圧縮率を好みに合わせて自由に設定できます。',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. 手順ガイド',
          steps: [
            {
              heading: '1. 圧縮したい画像を選択します。',
              bullets: [
                '画像をドラッグ＆ドロップでアップロード枠に入れます。',
                '画像をコピーして (Ctrl + V) で貼り付けることもできます。',
                '選択ボタンからファイルエクスプローラーを使って選ぶこともできます。',
              ],
            },
            {
              heading: '2. 圧縮率を選択します。',
              bullets: [
                '横向きスライダーで快適に圧縮率を設定できます。より正確な結果のため、以下の範囲を目安にしてください。',
              ],
              table: {
                headers: ['圧縮率', '結果'],
                rows: [
                  ['1%  〜  40%', '高品質'],
                  ['41%  〜  60%', '標準品質（推奨）'],
                  ['61%  〜  100%', '低品質'],
                ],
              },
            },
            {
              heading: '3. 節約できた容量を確認します。',
              paragraphs: [
                '容量に関する指標はリアルタイムで表示されます。全体のうちどれだけ削減できたかを確認しながら、必要なファイルサイズに合わせて圧縮率を調整できます。',
              ],
            },
            {
              heading: '4. 切替ボタンでダウンロード方法を選びます。',
              bullets: [
                'ZIP：複数画像を圧縮するとこの選択肢が表示されます。選ぶと、圧縮後の画像を1つの ZIP にまとめます（大量画像に推奨）。',
                '個別：各画像を ZIP ではなく個別にダウンロードします（少数画像、10枚未満に推奨）。',
              ],
            },
            {
              heading: '5. 画像を圧縮してダウンロードします。',
              paragraphs: [
                'このボタンを押すと、選択したダウンロード方法で圧縮済み画像が自動的にダウンロードされます。',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. 画像圧縮のメリット。',
          bullets: [
            '保存コストの削減：画像を圧縮することで必要なストレージ容量を大幅に減らせます。',
            '表示速度の向上：圧縮画像は読み込みが速く、サイトやアプリの体験を向上させます。',
            'Gmail 添付上限への対策：Gmail の添付上限（25MB）に対し、圧縮でより多くのファイルを送れます。',
            '共有・転送の高速化：大きいファイルは送受信に時間がかかるため、圧縮で時間と通信量を節約できます。',
            'プレゼン最適化：非圧縮画像の多い資料は重くなりがちですが、圧縮で容量を大幅に減らせます。',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. 対応形式。',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  converter: {
    seo: {
      uploadTitle: '画像変換 — PNG、JPG、WEBP、GIF、SVGを無料変換 | photremium.com',
      uploadDesc: '画像をJPG、PNG、WEBP、GIF、SVG、TIFF、BMP間で変換。無料オンライン画像フォーマット変換 — 高速・プライベート・登録不要。',
      uploadKeywords: '画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',
      workspaceKeywords: '画像変換, フォーマット変換, バッチ変換',

      routeKeywords: {

        'png-to-jpg': 'png 変換する jpg, png to jpg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'jpg-to-png': 'jpg 変換する png, jpg to png, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'png-to-webp': 'png 変換する webp, png to webp, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'jpg-to-webp': 'jpg 変換する webp, jpg to webp, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'webp-to-jpg': 'webp 変換する jpg, webp to jpg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'webp-to-png': 'webp 変換する png, webp to png, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'gif-to-jpg': 'gif 変換する jpg, gif to jpg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'gif-to-png': 'gif 変換する png, gif to png, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'bmp-to-jpg': 'bmp 変換する jpg, bmp to jpg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'bmp-to-png': 'bmp 変換する png, bmp to png, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'svg-to-png': 'svg 変換する png, svg to png, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'svg-to-jpg': 'svg 変換する jpg, svg to jpg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'tiff-to-jpg': 'tiff 変換する jpg, tiff to jpg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'tiff-to-png': 'tiff 変換する png, tiff to png, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'jpg-to-gif': 'jpg 変換する gif, jpg to gif, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'png-to-gif': 'png 変換する gif, png to gif, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'jpg-to-bmp': 'jpg 変換する bmp, jpg to bmp, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'png-to-bmp': 'png 変換する bmp, png to bmp, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'webp-to-gif': 'webp 変換する gif, webp to gif, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'jpg-to-ico': 'jpg 変換する ico, jpg to ico, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'png-to-ico': 'png 変換する ico, png to ico, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'jpg-to-svg': 'jpg 変換する svg, jpg to svg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'png-to-svg': 'png 変換する svg, png to svg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'webp-to-svg': 'webp 変換する svg, webp to svg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'gif-to-svg': 'gif 変換する svg, gif to svg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'bmp-to-svg': 'bmp 変換する svg, bmp to svg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

        'tiff-to-svg': 'tiff 変換する svg, tiff to svg, 画像変換, PNGをJPGに変換, JPGをPNGに, WEBP変換',

      },
    },
    title: '画像変換',
    desc: '画像をJPG、PNG、WEBP、GIF、SVG、TIFF、BMPなど複数のフォーマット間で変換。一度に複数ファイルをバッチ変換。',
    toConvert: '変換する',
    convertSettings: '変換設定',
    detected: '検出',
    convertTo: '変換先',
    converting: '変換中…',
    convertToFormat: '{format}に変換',
    popularConversions: '人気の変換',
    convertingTo: '変換先:',
    all: 'すべて',
  },
  resizer: {
    seo: {
      uploadTitle: '画像リサイズ — JPG、PNG、SVG、GIFを無料でサイズ変更 | photremium.com',
      uploadDesc: 'ピクセルまたはパーセントでオンライン画像リサイズ。品質を維持しながらJPG、PNG、SVG、GIFをリサイズ。',
      uploadKeywords: '画像リサイズ, サイズ変更, JPGリサイズ, PNGリサイズ',
      workspaceTitle: '画像をリサイズ中 — photremium.com',
      workspaceDesc: '画像をオンラインで無料リサイズ。',
      workspaceKeywords: '画像リサイズ',
    },
    title: '画像リサイズ',
    desc: 'JPG、PNG、SVG、GIF画像をピクセル、パーセント、センチメートル、またはインチでサイズ変更。複数ファイルを一括リサイズ。',
    toResize: 'リサイズする',
    resizeSettings: 'リサイズ設定',
    resizeBy: 'リサイズ基準:',
    byPixels: 'ピクセル',
    byPercentage: 'パーセント',
    byCentimeters: 'センチメートル',
    byInches: 'インチ',
    advanced: '詳細設定',
    lockAspect: 'アスペクト比を固定',
    unlockAspect: 'アスペクト比を解除',
    dontEnlarge: '元より小さい場合は拡大しない',
    resizing: 'リサイズ中…',
    resizeDownload: 'リサイズしてダウンロード',
    blog: {
      tocTitle: '目次',
      title: '画像リサイズ ブログ',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. なぜ画像リサイザーを使うのか？',
          paragraphs: [
            '画像リサイザーは、画像の寸法を変更するためのツール（ソフトウェア）です。高さ・幅、またはその両方を変更して、目的の画像サイズに調整できます。画像の投稿・アップロード時にサイズ制限があるSNSプラットフォームで特に役立ちます。',
          ],
          listTitle: '例えば：',
          bullets: [
            'Instagram投稿: 1080 x 1080px（正方形）',
            'Facebook投稿: 1200 x 630px',
            'X（旧Twitter）投稿: 1200 x 675px',
            'Instagramストーリー: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. なぜ当社の画像リサイズツールを選ぶのか？',
          paragraphs: [
            '当社のAI搭載画像リサイザーは、リサイズ作業を正確かつ非常に高速に行えます。どのデバイスでもスムーズに利用でき、アプリのインストールやダウンロードは不要です。すべての機能がブラウザ上で利用できます。',
          ],
          bullets: [
            '複数画像（100枚以上も可）を一度にリサイズできます。高性能なデバイスなら、400〜500枚でも数秒で処理できます。',
            'すべての処理はローカルブラウザで実行されます。画像を当社サーバーへアップロードする必要はありません。画像はデバイス外へ出ないため、プライバシー面でも安心です。',
            'リサイズ単位は複数対応しています。',
            'チェックボックスを選ぶだけで、リサイズ後も元のアスペクト比を維持できます。',
            '複数画像をリサイズする場合、個別ダウンロードまたはZIPダウンロードを選べます。',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. 手順ガイド',
          steps: [
            {
              heading: 'まず、リサイズしたい画像（または複数画像）を選択します。画像の選択方法は複数あります。',
              bullets: [
                '画像をドラッグ＆ドロップしてリサイズできます。',
                '「Ctrl + V」ショートカットで画像をドロップボックスへ貼り付けることもできます。',
                '「Choose Files」ボタンを押すとファイルエクスプローラーが開き、画像を選択できます。',
              ],
            },
            {
              heading: '次に、リサイズ単位を選択します。現在、以下の単位に対応しています：',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: '単位を選択したら、高さと幅を調整して画像をリサイズします。チェックボックスでアスペクト比を固定することもできます。',
            },
            {
              heading: '元画像より大きくしたくない場合は「Don’t enlarge if original is smaller」にチェックを入れます。',
            },
            {
              heading: 'その後、ダウンロード方法を選択します。',
              bullets: [
                '複数画像を1つのzipファイルでダウンロードしたい場合はZIPを選択します。',
                '各画像を個別にダウンロードしたい場合は「separate」を選択します。',
              ],
            },
            {
              heading: '最後に「Resize & Download」ボタンを押して、選択した方法でリサイズ画像をダウンロードします。',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. 画像リサイズツールのメリット：最も大きなメリットは、WebページやSNS投稿で画像を適切に配置できることです。',
          tocLabel: '4. 画像リサイズツールのメリット',
          bullets: [
            'UX向上：適切なサイズと配置はユーザー体験を大きく向上させます。大きすぎる画像・小さすぎる画像を調整せずに配置するとUXが低下します。',
            'SNS対応：多くのSNSアプリには投稿画像のサイズ制限があります。当社ツールはその必要サイズへ簡単に合わせられます。',
            'レスポンシブデザイン：開発者がレスポンシブデザインを作る場合、複数デバイス対応のために画像を複数サイズで用意する必要があります。',
            '最適な選択：画像を引き伸ばしたり切り抜いたりすると寸法バランスが崩れることがありますが、リサイズはより適切な方法です。',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. 対応フォーマット：当社の画像リサイザーは、あらゆる形式の画像をリサイズ対象として選択できます。対応形式は以下です：',
          tocLabel: '5. 対応フォーマット',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  cropper: {
    seo: {
      uploadTitle: '画像トリミング — JPG、PNG、GIFを無料でトリミング | photremium.com',
      uploadDesc: 'JPG、PNG、GIF画像をオンラインで簡単にトリミング。ビジュアルエディタでプリセット比率または自由トリミング。',
      uploadKeywords: '画像トリミング, JPGトリミング, PNGトリミング',
      workspaceTitle: '画像をトリミング中 — photremium.com',
      workspaceDesc: '画像をオンラインで無料トリミング。',
      workspaceKeywords: '画像トリミング',
    },
    title: '画像トリミング',
    desc: 'JPG、PNG、GIFなどをビジュアルエディタでトリミング。プリセット比率または自由形式のトリミングが可能。',
    toCrop: 'トリミングする',
    cropSettings: 'トリミング設定',
    widthPx: '幅 (px)',
    heightPx: '高さ (px)',
    positionX: 'X位置 (px)',
    positionY: 'Y位置 (px)',
    cropTemplate: 'トリミングテンプレート',
    landscape: '横向き',
    portrait: '縦向き',
    square: '正方形',
    freeform: '自由形式',
    cropping: 'トリミング中…',
    cropDownload: 'トリミングしてダウンロード',
    cropDownloadAll: 'すべてトリミングしてダウンロード',
    saveNext: '保存して次へ',
    croppedNofTotal: '{total}枚中{n}枚をトリミングしました。',
    downloadN: '{n}枚ダウンロード',
  },
  photoEditor: {
    seo: {
      title: 'オンラインフォトエディタ — テキスト・エフェクト・フレームで無料編集 | photremium.com',
      desc: '写真をオンラインで無料編集 — テキスト、エフェクト、フレーム、ステッカーなどを追加。ブラウザで動作するシンプルな画像編集ツール。',
      keywords: 'フォトエディタ, オンライン写真編集, 無料写真編集, 画像テキスト追加',
    },
    title: 'フォトエディタ',
    desc: 'テキスト、エフェクト、フレーム、ステッカーで写真を彩ります。すべての画像ニーズに対応したシンプルな編集ツール。',
    toEdit: '編集する',
    textTypography: 'テキスト＆タイポグラフィ',
    textTypographyDesc: 'さまざまなフォント、色、影、配置オプションでカスタムテキストを追加。',
    filtersEffects: 'フィルター＆エフェクト',
    filtersEffectsDesc: 'プロフェッショナルフィルターを適用し、明度・コントラスト・彩度などを調整。',
    framesStickers: 'フレーム＆ステッカー',
    framesStickersDesc: '美しいフレームと楽しいステッカーで画像を彩ります。',
  },
  removeBg: {
    seo: {
      uploadTitle: '画像背景除去 — オンラインで無料 | photremium.com',
      uploadDesc: '高精度で画像の背景を素早く除去。無料オンライン背景リムーバー — ブラウザ内で完全動作。',
      uploadKeywords: '背景除去, 背景リムーバー, 透明背景, 切り抜き',
      workspaceTitle: '背景除去中 — photremium.com背景リムーバー',
      workspaceDesc: '画像の背景をオンラインで無料除去。',
      workspaceKeywords: '背景除去',
    },
    title: '背景除去',
    desc: '高度なエッジ検出で画像から背景を即座に除去。100%無料、ブラウザ内で完全動作 — アップロードなし、サーバーなし。',
    toRemoveBg: '背景を除去する',
    backgroundRemover: '背景リムーバー',
    processingProgress: '処理の進捗',
    processingNImages: '{n}枚の画像を処理中…',
    allNProcessed: '{n}枚の画像すべてを処理しました！',
    nOfTotalDone: '{n} / {total} 完了',
    fileName: 'ファイル名',
    dimensions: 'サイズ',
    status: 'ステータス',
    statusDone: '✓ 完了',
    statusProcessing: '⏳ 処理中',
    statusError: '✗ エラー',
    statusPending: '⏸ 待機中',
    badgeDone: '完了',
    badgeProcessing: '処理中…',
    badgeError: 'エラー',
    removingBg: '背景を除去中…',
    retry: '再試行',
    downloading: 'ダウンロード中…',
    nextImage: '次の画像',
  },
  watermark: {
    seo: {
      uploadTitle: '透かし追加 — テキスト・ロゴ透かしを無料追加 | photremium.com',
      uploadDesc: '数秒で写真にテキストまたは画像透かしを追加。無料・高速・プライベート。',
      uploadKeywords: '透かし追加, テキスト透かし, ロゴ透かし',
      workspaceTitle: '透かし追加中 — photremium.com透かしツール',
      workspaceDesc: '画像に透かしをオンラインで無料追加。',
      workspaceKeywords: '透かし追加',
    },
    title: '透かし追加',
    desc: '画像にテキストまたはロゴの透かしを追加。フォント・不透明度・サイズ・位置などをカスタマイズ。ブラウザ内で完全動作。',
    toWatermark: '透かしを入れる',
    watermarkTools: '透かしツール',
    addText: 'テキストを追加',
    addImage: '画像を追加',
    layersN: 'レイヤー ({n})',
    noLayers: 'まだレイヤーが追加されていません',
    textLayer: 'テキストレイヤー',
    imageLayer: '画像レイヤー',
    watermarkDownloadAll: '透かしを入れてすべてダウンロード',
    watermarkDownload: '透かしを入れてダウンロード',
    nextImage: '次の画像',
    privateMode: 'プライベートモード',
    privateModeOn: 'プライベートモード ON: この画像では透かしの移動とサイズ変更のみ…',
    privateModeHint: 'プライベートモードを有効にして位置とサイズのみ調整…',
    privateModeActive: 'プライベートモード — 移動・リサイズ・フォントサイズ変更のみ許可',
    selectToEdit: '編集を開始するには画像またはテキストを選択してください',
    bold: '太字',
    italic: '斜体',
    underline: '下線',
    bgColor: '背景色',
    textColor: 'テキスト色',
    alignLeft: '左揃え',
    alignCenter: '中央揃え',
    alignRight: '右揃え',
    opacity: '不透明度',
    stroke: 'ストローク',
    strokeWidth: 'ストローク幅',
    strokeColor: 'ストローク色',
    tileRepeat: 'タイル / 繰り返し',
    tilePattern: 'タイルパターン',
    spacing: '間隔',
    snapToCenter: '中央にスナップ',
    duplicate: '複製',
    delete: '削除',
    flipHorizontal: '水平反転',
    flipVertical: '垂直反転',
    rotateLeft: '左に回転',
    rotateRight: '右に回転',
    cornerRadius: '角の半径',
    borderStroke: '枠線 / ストローク',
    borderWidth: '枠線幅',
    color: '色',
    style: 'スタイル',
    hide: '非表示',
    show: '表示',
    lock: 'ロック',
    unlock: 'ロック解除',
    solid: '実線',
    dashed: '破線',
    dotted: '点線',
    double: '二重線',
    tileSingle: '単一',
    tile2x2: '2×2グリッド',
    tile3x3: '3×3グリッド',
    removeAllConfirm: 'すべての画像と透かしを削除しますか？',
    dimMismatch: 'アップロードされた画像のサイズが異なります。最良の結果を得るには同じ解像度の画像をアップロードするか、一枚ずつ透かしを適用してください。',
    clearBackground: '背景をクリア',
    typeHere: 'ここに入力...',
    linkCorners: '角を連結',
    separateCorners: '角を分離',
    blog: {
      tocTitle: '目次',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: '透かしツールの概要',
          title: '画像にオンラインで透かしを追加する方法 — Photremiumの透かしツール完全ガイド',
          paragraphs: [
            '美しい写真の編集を終えたばかりです。店の商品写真かもしれませんし、クライアントとの撮影で撮ったポートレート、あるいは何時間もかけて仕上げたデジタルアートかもしれません。そして、すべてのクリエイターが最終的に直面する問いがやってきます。共有する前に、どうやって守るのか。',
            '多くのプロがたどり着く答えは透かしです。そして、それには十分な理由があります。適切に配置された透かしは、作品の恒久的な署名として機能し、追跡可能で、ブランドを示し、盗みにくくします。',
            '多くの人がぶつかる問題は、オンラインで使えるツールが、使いづらすぎるか、サブスクリプションの奥に隠れているか、あるいは透かしが重すぎて画像全体を台無しにしてしまうことです。',
            'PhotremiumのWatermark Imageツールは、そのすべてを解決するために作られました。完全にブラウザベースで、無料、アカウント不要の透かし作業スペースで、ファイルをサーバーに送ることなく、ブラウザの中だけで動作します。すべてはローカルのまま、すべては高速のまま、そして創作上のコントロールはデスクトップソフトに匹敵します。このガイドでは、その仕組み、対象ユーザー、そして毎回最良の結果を得る方法を詳しく説明します。',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: '透かしとは',
          title: '透かしとは何か、なぜ重要なのか？',
          paragraphs: [
            'ツールそのものに入る前に、透かしが何をするのか、そしてなぜ多くの写真家、デザイナー、コンテンツ制作者が欠かせないと考えるのかを理解しておく価値があります。',
            '透かしとは、画像に追加される目に見えるオーバーレイで、通常はテキスト、ロゴ、著作権記号などが使われ、作成者や所有者を識別します。メタデータのようにファイルの中に隠れていて数秒で消せるものとは異なり、透かしは画像そのものに視覚的に埋め込まれます。右クリックするだけで、目立った画質劣化なしに削除することはできません。',
          ],
          subSections: [
            {
              title: 'クリエイターが透かしを使う理由',
              paragraphs: [
                '画像に透かしを入れる実用的な理由は、3つの主要な懸念に集約されます。',
              ],
              bullets: [
                '所有権の識別。作品がSNS、Pinterestのボード、ブログ記事に埋め込まれて共有されると、元のクレジットは失われがちです。透かしがあれば、画像がどこへ行っても名前やブランドを一緒に運べます。',
                '盗難の抑止。画像を盗む人の多くは、最も抵抗の少ない方法を探しています。見た目にプロらしく、適切な位置に置かれ、少し透明な透かしは、「この画像は自分の仕事を大切にする人のものだ」という明確なメッセージを送ります。',
                'クライアントのポートフォリオ保護。最終支払い前にクライアントへプレビューを共有する写真家は、請求書が支払われる前にプレビューを使われないよう、透かしをよく使います。控えめな透かしなら、プレビューの評価を邪魔しすぎずにそれを実現できます。',
              ],
            },
            {
              title: '誰が画像に透かしを入れるべきか',
              paragraphs: [
                '以下のいずれかに当てはまるなら、オンラインで共有する前に画像へ透かしを入れるのは任意ではなく必須です。',
              ],
              bullets: [
                'クライアントにギャラリーを共有するフリーランス写真家',
                'ポートフォリオサンプルを配布するグラフィックデザイナー',
                'ライセンス契約前に商品写真を見せるEC販売者',
                'SNSで作品を共有するデジタルアーティスト',
                '画像が頻繁に再利用されるブロガーやコンテンツ制作者',
                '認知されやすいブランドを構築するストックフォト提供者',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'ワークスペースのパネル',
          title: 'Photremiumの透かしツールの内部: 実際の作業フローのために作られた3パネルのワークスペース',
          paragraphs: [
            'Photremiumの透かしツールが基本的なオンライン透かしツールと違うのは、ワークスペース設計です。単純な「文字を入力して位置を選んで終わり」という方法ではなく、プロ向けデザインソフトに近い3パネル構成を採用しています。ただし、完全にブラウザ上で動作し、インストールは不要です。',
          ],
          subSections: [
            {
              title: '左側のキャンバスパネル',
              paragraphs: [
                'キャンバスパネルは画面の大部分を占め、透かしを適用した画像がリアルタイムでどう見えるかを正確に表示します。透明度の調整、テキストレイヤーの再配置、ロゴのサイズ変更など、すべての変更が即座にキャンバスへ反映されます。「プレビュー」ボタンを押す必要はありません。見えているものがそのまま結果です。',
                'キャンバスにはズーム用のツールバーも組み込まれており、正確な位置合わせのために拡大し、全体像を見るために縮小できます。画面に合わせる機能は、画面サイズに基づいて最適な初期スケールを自動計算するため、高解像度画像でも快適な作業サイズで読み込まれます。画像の水平または垂直の中央付近にレイヤーをドラッグすると整列ガイドが動的に現れ、Photoshopでしか得られないような気持ちいい精度で透かしがど真ん中に吸い付くように配置されます。',
              ],
            },
            {
              title: '右側の設定パネル',
              paragraphs: [
                '右側パネルはコントロールセンターです。ここで透かしレイヤーを管理し、見た目を調整し、最終書き出しを実行します。デスクトップでは画面右側に固定されています。モバイルでは、フローティングの歯車ボタンで呼び出される下部シートとして上がってくるため、作業中にキャンバスを覆いません。',
                '右側パネルにはレイヤーマネージャーがあり、追加したすべての透かし要素が一覧表示されます。各レイヤー項目には、レイヤーの種類（テキストか画像か）、現在の名前または内容、そして3つのクイック操作ボタンが表示されます。表示切り替え（目のアイコン）、他のレイヤーを操作している間に位置を固定するロック切り替え、削除ボタンです。',
              ],
            },
            {
              title: '左側のプレビュー帯（複数画像モード）',
              paragraphs: [
                '複数の画像を同時に扱う場合、たとえば商品写真の一括処理やポートレート撮影全体を扱う場合、画面左端に縦長のサムネイル帯が表示されます。これが画像キューで、読み込んだ各ファイルの小さなプレビューが並びます。サムネイルをクリックすると、その画像に即座にキャンバスが切り替わり、レイヤー設定を失うことなく、異なる構図で透かしがどう見えるかを確認できます。',
                '帯には各ファイルのKBまたはMBのサイズ表示と、JPG、PNG、WEBPのファイル形式ラベルも表示されるため、一目で何を扱っているのか分かります。',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: '手順',
          title: '手順: Photremiumで画像に透かしを追加する方法',
          paragraphs: [
            'この手順は、ドラッグ＆ドロップのアップロードから、ダウンロード前に透かしを画像へ恒久的に書き込むキャンバスのレンダリングエンジンまで、ツールの内部動作に直接基づいています。',
          ],
          steps: [
            {
              heading: '手順1 — 画像をアップロードする',
              paragraphsBefore: [
                'photremium.com/watermark-image にアクセスします。ページ中央にすっきりしたドラッグ＆ドロップ領域があるアップロード画面が表示されます。',
                '画像をツールに入れる方法は3つあります。',
              ],
              bullets: [
                'ドラッグ＆ドロップ。デスクトップから1つ以上の画像ファイルを、そのままドロップゾーンへドラッグします。ツールはJPEG、PNG、WEBPなど、標準的な画像形式を受け付けます。ワークスペース上にファイルをドラッグすると、エリア全体が紫の枠で反応し、「Drop images to add for watermarking」という視覚的な案内が表示されるため、ドロップが認識されたことが分かります。',
                'クリックして選択。ドロップゾーン内の「Choose Files」ボタンをクリックして、システムのファイルピッカーを開きます。WindowsではCtrl+Click、MacではCmd+Clickで複数ファイルをまとめて選択できます。',
                'クリップボードから貼り付け。スクリーンショット、別のアプリ、Webブラウザなどから画像をクリップボードにコピーしている場合、透かしページでCtrl+V（MacではCmd+V）を押すだけで、画像がそのままワークスペースに読み込まれます。複数画像がすでに読み込まれている場合でも動作します。',
              ],
              paragraphsAfter: [
                '最初の画像が読み込まれると、ワークスペースはアップロード画面から3パネルの完全なエディタへ移行し、キャンバスには画面サイズに合わせて自動計算されたズームレベルで画像が表示されます。',
              ],
            },
            {
              heading: '手順2 — テキスト透かしレイヤーを追加する',
              paragraphsBefore: [
                '右側パネルの紫色の「Add Text」ボタンをクリックします。キャンバス上に新しいテキストレイヤーが現れ、デフォルトのプレースホルダーテキスト「Type here...」が選択された状態になります。',
                'すぐに入力を始められます。テキストはキャンバス上で白いArialとしてライブ表示され、画像のサイズに合わせたデフォルト値で描画されます。テキストレイヤーを選択すると上部に表示されるツールバーから、テキストのあらゆる要素をカスタマイズできます。',
              ],
              bullets: [
                'フォントファミリー — Arial、Georgia、Impact、Brush Script MT、Comic Sans MS など、12種類の内蔵フォントから選択',
                'フォントサイズ — ピクセル値を直接入力するか、増減コントロールを使う',
                '太字、斜体、下線 — これらのスタイルを任意に組み合わせる',
                'テキスト色 — カラースウォッチをクリックしてカラーピッカーを開き、任意のhexカラーを選ぶ',
                '背景色 — テキストの背後に色付き背景を追加して、ラベルやバッジ風の見た目にする',
                'ストローク（輪郭） — 明るい画像でも暗い画像でも最高の視認性が得られるよう、線幅と色を設定',
                '不透明度 — 0%（不可視）から100%（完全不透明）まで調整。多くの透かしは30%〜60%の間に置かれます',
                '配置 — テキストをバウンディングボックス内で左揃え、中央揃え、右揃えにする',
                '回転 — テキストレイヤーを任意の角度に回転。0°、90°、180°、270°で磁気スナップが働き、素早く直角配置できます',
              ],
              paragraphsAfter: [
                'テキストを動かすには、キャンバス上の好きな場所へクリック＆ドラッグします。ピクセル単位で細かく調整するには、キーボードの矢印キーを使います（Shiftを押しながらで10ピクセル単位）。テキストボックスのサイズ変更は、選択したレイヤーの周囲に表示される8つのリサイズハンドル（角と辺）をドラッグします。',
              ],
            },
            {
              heading: '手順3 — 画像（ロゴ）透かしレイヤーを追加する',
              paragraphsBefore: [
                'ロゴ、署名、または任意の画像を、テキストの代わりに、あるいはテキストに加えて透かしとして使いたい場合は、右側パネルの青い「Add Image」ボタンをクリックします。ファイルピッカーが開き、デバイスから透かし用画像ファイルを選べます。',
                'ツールは透かし画像を自動的にキャンバス幅の約30%に調整し、元のアスペクト比を維持したまま中央に配置します。そこから、任意の位置にドラッグしたり、角ハンドルでサイズ変更したり（アスペクト比は維持）、選択レイヤーの上に出る専用の回転ハンドルで回転させたりできます。',
                '画像タイプの透かしレイヤーには、右側パネルで追加のコントロールが表示されます。',
              ],
              bullets: [
                '不透明度 — テキストレイヤーと同様。透明PNGロゴに最適',
                '水平方向に反転 / 垂直方向に反転 — 必要に応じて透かしを鏡像化',
                '枠線幅、枠線色、枠線スタイル — ロゴ透かしの周囲に見える枠を追加',
                '角丸半径 — ロゴの角を一様に、または各角ごとに個別に丸める',
                '回転 — テキストレイヤーと同じスムーズな回転動作',
              ],
            },
            {
              heading: '手順4 — タイル化を設定する（任意）',
              paragraphsBefore: [
                'このツールの強力な機能の1つがタイル化です。画像全体にグリッド状で透かしを繰り返すことができます。これは、単にブランドを入れるだけでなく、再公開に使えないようにしたい場合に特に便利です。',
                'レイヤーを選択した状態で、ツールバーの tile オプションを探します。次のように設定できます。',
              ],
              bullets: [
                'なし — 単一配置（既定）',
                '2×2 グリッド — 2列×2行のパターンで透かしを繰り返す',
                '3×3 グリッド — より密なカバレッジのために3×3グリッドで繰り返す',
              ],
              paragraphsAfter: [
                'タイル間の間隔も調整できます。これにより、繰り返しごとの距離が制御されます。キャンバスはタイル化されたすべてのコピーをゴーストプレビューで表示するため、ダウンロード前に完全なカバレッジを確認できます。',
              ],
            },
            {
              heading: '手順5 — レイヤーマネージャーで複数の透かしを扱う',
              paragraphsBefore: [
                '必要なだけレイヤーを追加できます。テキスト透かしと画像透かしを自由に組み合わせられます。右側パネルのレイヤーマネージャーにすべて一覧表示されます。できることは以下です。',
              ],
              bullets: [
                '目のアイコンで個別レイヤーの表示/非表示を切り替える。削除せずに別バージョンの透かしへ切り替えるのに便利',
                '他のレイヤーを操作している間に、誤って動かさないようレイヤーをロックする',
                'レイヤーを完全に削除する',
              ],
              paragraphsAfter: [
                '一覧のレイヤー項目をクリックすると、同時にキャンバス上でも選択されるため、画像を探し回ることなくレイヤーを切り替えられます。',
              ],
            },
            {
              heading: '手順6 — 複数画像の切り替え',
              paragraphsBefore: [
                '複数の画像をアップロードした場合は、左側のサムネイル帯を使ってアクティブなキャンバス画像を切り替えます。設定した透かしレイヤーは共通して適用され、書き出し時にバッチ内のすべての画像へレンダリングされます。',
                'ツールはバッチ全体の解像度整合性もチェックします。画像のサイズが大きく異なる場合（幅または高さが5%以上違う場合）は、サイズ差により透かしの位置が画像ごとに異なって見える可能性があるという警告が表示されます。エンジンは比例再配置アルゴリズムでこれをうまく処理し、基準画像のサイズに対する割合として透かし位置を計算し、同じ比例配置を他のすべての画像に適用して、解像度が違っても視覚的な意図を保ちます。',
              ],
            },
            {
              heading: '手順7 — ダウンロード設定を行う',
              paragraphsBefore: [
                '単一画像の作業では、キャンバス下の「Download」ボタンをクリックして透かし付き画像を直接保存します。ファイル名は元の名前に「-watermarked」を拡張子の前へ追加したものに自動設定されます。JPEG画像は品質0.95で書き出され、通常の閲覧サイズでは元画像と見分けがつかないほど高品質です。PNG画像はロスレスPNGとして書き出されます。',
                '複数画像のバッチ処理では、右側パネルで2つのダウンロードモードを選べます。',
              ],
              bullets: [
                'ZIPファイル — すべての透かし付き画像を1つのZIPアーカイブにまとめ、ワンクリックでダウンロード。圧縮処理のためにJSZipが動的に読み込まれます。',
                '個別ファイル — 各画像を個別ファイルとしてダウンロード。ブラウザの制限を避けるため、ダウンロード間に短い間隔が入ります。',
              ],
            },
            {
              heading: '手順8 — ダウンロードして確認する',
              paragraphsBefore: [
                'ダウンロードボタン（またはバッチの場合は「Watermark & Download All」ボタン）をクリックすると、ツールは各画像を非表示のHTML5 canvas要素上で元のネイティブ解像度そのままにレンダリングします。画面上の縮小プレビューではありません。つまり、書き出された画像は元のピクセル寸法の100%で、透かしは比例的に正しいサイズで描画されます。ダウンロードしたファイルを開いて拡大し、透かしの位置と品質が期待どおりか確認してください。',
                '何かおかしければ、ワークスペースに戻るだけです。レイヤーはそのまま残っているので、調整して再度ダウンロードしてください。',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'プロ向けヒント',
          title: '最高の結果を得るためのプロ向けヒント',
          bullets: [
            '最もプロらしく見せたいなら、半透明PNGロゴを使いましょう。透明背景で40〜50%の不透明度のロゴ透かしは、無地のテキストよりずっと洗練されて見えます。画像レイヤーとして使う前に、デザインツールからアルファ透過付きPNGとしてロゴを書き出してください。',
            '切り抜かれると価値が失われる場所に透かしを置きましょう。右下は最も一般的な配置で、最も簡単に切り抜かれます。より強い保護が必要なら、顔、商品のディテール、主題など、視覚的に重要な領域の上に置くことを検討してください。対角タイルは、画像を大きく損なわずに消すのがさらに難しくなります。',
            '複数レイヤーを扱うときはロック機能を使いましょう。メインの透かし位置に満足したら、そのレイヤーをロックしてから次のレイヤーを追加します。こうすることで、他の要素を調整している間に誤ってずらすことを防げます。',
            '画像の明るい部分と暗い部分の両方でテストしましょう。白い透かしは明るい空では見えませんが、暗い影でははっきり読めます。控えめなストロークや背景色を追加して、透かしの下に何があっても読みやすくしてください。',
            'キーボードショートカットは常に時間を節約します。矢印キーは選択したレイヤーを1ピクセルずつ移動します。Shift+矢印で10ピクセルずつ移動します。Deleteキーで選択中レイヤーを即座に削除できます。これらのショートカットで、位置の微調整はドラッグよりずっと速くなります。',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'プライバシーとセキュリティ',
          title: 'プライバシーとセキュリティ: ブラウザベースの処理が重要な理由',
          paragraphs: [
            'オンラインツールを使う際、多くのクリエイターが気にするのは、画像が実際にどこへ行くのかという点です。サーバーベースの透かしツールでは、画像は提供元のサーバーにアップロードされ、そこで処理されてから戻ってきます。つまり、未公開の作品、クライアント写真、機密性の高い商品画像が他人のインフラを通過することになります。',
            'Photremiumの透かしツールは、すべてをブラウザ内でローカル処理します。画像はブラウザのFile APIを使って端末のメモリに読み込まれ、インターネットに送信されることはありません。透かしの描画は、JavaScriptで動くHTML5 canvas上で、完全にブラウザタブの中だけで行われます。ページを閉じるか「Start Over」をクリックすると、画像データはすべてメモリから解放され、破棄されます。自分の端末の外に保存されるものは何もありません。',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: '最終まとめ',
          title: 'Photremiumの透かしツールが普段の作業フローに入る理由',
          paragraphs: [
            'オンラインには数多くの透かしツールがあります。ブックマークする価値があるかどうかを分けるのは、たいてい速度、コントロール、信頼性の組み合わせです。',
            '速度が重要なのは、透かし処理が後処理ワークフローの大きな時間増加になってはいけないからです。Photremiumのツールは即座に読み込まれ、ローカル処理され、数秒でフル解像度で書き出されます。大規模なバッチでも同じです。サーバー側処理を待つ必要も、キューも、オンライン人数に応じて伸びるレンダリング時間もありません。',
            'コントロールが重要なのは、見た目の悪い透かしは透かしがないより悪いからです。ブランドを不格好に見せてしまいます。レイヤーシステム、ツールバーの個別プロパティ操作、リアルタイムのキャンバスプレビュー、キーボードショートカット対応が合わさることで、専用のデスクトップソフトに本当に匹敵するレベルのコントロールが得られます。',
            '信頼性が重要なのは、未公開の作品が価値あるものだからです。画像がインターネットを通って第三者のサーバーへ行かないと分かっていれば、クライアント写真、未発表の商品画像、機密性の高いクリエイティブ作品も、データ処理やサーバー侵害、クラウド事業者のポリシー変更を気にせず透かしを入れられます。',
            '1枚の写真にさっと著作権表記を入れる場合でも、クライアントギャラリーを共有する前に200枚の撮影全体を処理する場合でも、PhotremiumのWatermark Imageツールは、完全無料、完全プライベート、そして画像の上に貼り付けたものではなく画像に属しているように見せるのに十分な創作の柔軟性を提供します。',
            'photremium.com/watermark-image にアクセスして試してみてください。最初の透かし付き画像は、本当に30秒後です。',
            'Photremiumは、ブラウザベースの画像編集・処理ツール群を提供しています。すべてのツールはブラウザ内でローカルに動作し、画像は端末上に残ります。',
          ],
        },
      ],
    },
  },
  qrGenerator: {
    seo: {
      inputTitle: 'QRコードジェネレーター — 無料で作成＆カスタマイズ | photremium.com',
      inputDesc: 'URL、テキスト、WiFi、連絡先、メール、Google MapsのカスタムQRコードを生成。色・形・フレーム・ロゴをカスタマイズし、複数フォーマットでダウンロード。',
      inputKeywords: 'QRコードジェネレーター, QRコード作成, カスタムQRコード',
      customizeTitle: 'QRコードカスタマイズ — photremium.com',
      customizeDesc: 'QRコードのスタイル、色、フレーム、ロゴをカスタマイズ。PNG、JPG、SVG、WEBP、PDFでダウンロード。',
      customizeKeywords: 'QRコードカスタマイズ, QRコードスタイル',
    },
    title: 'QRコードジェネレーター',
    desc: 'URL、テキスト、WiFi、連絡先、メール＆地図用のQRコードを生成・カスタマイズ・ダウンロード。完全無料、ブラウザで動作。',
    generate: '生成',
    scanQrCode: 'QRコードをスキャン',
    tabUrl: 'リンク / URL',
    tabText: 'テキスト',
    tabWifi: 'WiFi',
    tabContact: '連絡先',
    tabEmail: 'Gmail',
    tabMaps: 'Google マップ',
    enterUrl: 'URLを入力',
    enterText: 'テキストを入力',
    networkName: 'ネットワーク名 (SSID)',
    password: 'パスワード',
    encryption: '暗号化',
    hiddenNetwork: '非表示ネットワーク',
    contactName: '連絡先名（任意）',
    phoneNumber: '電話番号',
    emailAddress: 'メールアドレス',
    subject: '件名（任意）',
    body: '本文（任意）',
    searchLocation: '場所を検索',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'テキストをここに入力…',
    wifiNamePlaceholder: 'マイWiFi',
    passwordPlaceholder: 'パスワード',
    contactPlaceholder: '山田 太郎',
    phonePlaceholder: '+81 XX XXXX XXXX',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: '件名',
    bodyPlaceholder: 'メール本文…',
    locationPlaceholder: '都市・住所・場所を検索…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'なし',
    characters: '文字',
    qrGettingComplex: 'QRコードが複雑になっています — スキャンが難しくなる場合があります。',
    qrTooComplex: 'QRコードが複雑すぎます！ほとんどのスキャナーでは読み取れません。',
    generateCustomize: '生成＆カスタマイズ',
    editQrData: 'QRデータを編集',
    styleShape: 'スタイル＆形状',
    colorTab: '色',
    framesTab: 'フレーム',
    logoTab: 'ロゴ',
    templatesTab: 'テンプレート',
    fileFormatTab: 'ファイル形式',
    dotShape: 'ドット形状',
    cornerEyeOuter: 'コーナーアイ — 外側',
    cornerEyeInner: 'コーナーアイ — 内側',
    fgColor: '前景色',
    bgColor: '背景色',
    enableGradient: 'グラデーションを有効化',
    gradientType: 'グラデーションタイプ',
    linear: '線形',
    radial: '放射状',
    gradientColor1: 'グラデーション色1',
    gradientColor2: 'グラデーション色2',
    suggestedGradients: '推奨グラデーション',
    selectFrame: 'フレームを選択',
    selectLogo: 'ロゴを選択',
    uploadCustomLogo: 'またはカスタムロゴをアップロード',
    uploadImage: '画像をアップロード',
    customLogoApplied: 'カスタムロゴを適用しました',
    premadeTemplates: '既製テンプレート',
    templateHint: 'テンプレートをクリックしてスタイルをすぐに適用。',
    downloadFormat: 'ダウンロード形式',
    fgBgIdentical: '前景色と背景色が同じです — QRコードが見えなくなります！',
    fgBgSimilar: '前景色と背景色が非常に似ています — QRコードがスキャンしにくくなる場合があります。',
    preview: 'プレビュー',
    angle: '角度',
    downloadFormatBtn: '{format}をダウンロード',
    pngDesc: '可逆圧縮、透明サポート',
    jpgDesc: '一般的で汎用的なファイル形式',
    webpDesc: '最新フォーマット、最高の品質/サイズ',
    svgDesc: 'スケーラブルベクターグラフィック',
    pdfDesc: '印刷用ドキュメント',
    lat: '緯度:',
    lng: '経度:',
    qrCode: 'QRコード',
    scanMe: 'スキャンしてください',
    scanHere: 'ここでスキャン',
    blog: {
      card1: {
        title: '1. QRコードとは？',
        intro1: 'QRコードは “Quick Response code” の略です。保存された情報を非常に高速で読み取れるため、Quick Response（QR）コードと呼ばれています。',
        intro2: 'QRコードは機械によって読み取られる2次元デジタルコードです。中のデータは人間が直接読むことはできません。テキスト、連絡先番号、リンク、Googleマップの位置情報などをブロックに保存できます。',
        inventionTitle: 'QRコードはどのように発明されたか:',
        inventionText: 'QRコードは1994年に発明されました。Masahiro Hara氏とそのチームは、Toyota向けの自動車部品を製造していた日本企業Denso Waveで働いていました。従来のバーコードより多くの情報を保存できるコードを求めた結果、QRコードが誕生しました。',
        keyFeaturesTitle: 'QRコードの主な特長',
        keyFeatures: [
          {
            title: 'QRの仕組み',
            text: 'テキストやリンクを入力すると、その情報からQRコードが生成されます。QRジェネレーターは情報に応じて四角いモジュールを作成します。各モジュールはビットを表し、ビットが文字情報を保持します。',
          },
          {
            title: 'QRコードの構造',
            text: 'QRコードには向きを判別するための大きな四角が3つあり、情報（ビット）を保存する小さな四角モジュールで構成されています。',
          },
          {
            title: 'QRコードのデータ容量',
            text: '一般的にQRコードはバーコードより多くの情報を保存できます。QRコードはバーコードの進化版であり、基本的には2次元バーコードです。通常は約200文字を保存できます。400文字程度まで保存可能ですが、読み取りは難しくなる場合があります。400文字を超えるとコードが非常に複雑になり、多くの場合スキャンできなくなる可能性があります。',
          },
          {
            title: 'QRコードのエラー検出',
            text: 'QRコードの一部に傷がついたりビットが欠けたりしても、読み取り可能なことがあります。QRコードはReed-Solomon方式のエラー検出・訂正技術を使ってエラーを特定し、復元を行います。',
          },
        ],
        errorTitle: 'QRコードの誤り訂正レベル:',
        errorIntro: '利用シーンに応じて、次のような誤り検出・訂正レベルが使われます:',
        errorHeaders: {
          level: 'レベル',
          recovery: '復元可能率',
          bestUse: '最適な用途',
        },
        errorRows: [
          {
            level: '低 (L)',
            recovery: '~7%',
            useCases: [
              'QRコードをデジタル画面・Webサイト・清潔な環境で表示する場合に使われます。',
              'Gmail、連絡先番号、短いテキストなど小さな情報を格納する場合に適しています。',
            ],
          },
          {
            level: '中 (M)',
            recovery: '~15%',
            useCases: [
              '清潔な環境に設置するフライヤーやポスターで、損傷リスクが小さい場合に適しています。',
            ],
          },
          {
            level: '四分位 (Q)',
            recovery: '~25%',
            useCases: [
              '工場や屋外など、厳しい環境にQRコードを設置する場合に使われます。',
              '中央に小さなロゴを配置して一部モジュールが隠れる場合にも、このレベルが必要です。',
            ],
          },
          {
            level: '高 (H)',
            recovery: '~30%',
            useCases: [
              'QRコードに大きな損傷が生じる可能性がある場合に使われます。',
              '大きなロゴでQRコード中央を覆う場合に適しています。',
              '装飾の強いデザインにする場合にも有効です。',
            ],
          },
        ],
      },
      card2: {
        title: '2. なぜ当社のQRコードジェネレーターを選ぶのか？',
        intro: '当社のQRコードジェネレーターは、QRコード作成を非常に高速・安全・簡単にします。ビジネステーマに合わせて、より高度でプロフェッショナルなデザインにカスタマイズできます。色変更からロゴ挿入まで、すべてのカスタマイズ機能を永久無料で利用できます。',
        strengths: [
          {
            title: 'プロ仕様のカスタマイズ:',
            text: '必要なだけQRコードを無料で作成・カスタマイズできます。すべての機能が完全無料です。グラデーションカラー、モジュール形状の変更、カスタムロゴなど多数の機能を利用できます。',
          },
          {
            title: '複数フォーマット対応:',
            text: '使いやすさのために複数のダウンロード形式を提供しています。ダウンロード前に希望の形式を選ぶだけです。現在は次の形式に対応しています:',
          },
          {
            title: 'プリセットテンプレート:',
            text: 'あらかじめ用意されたグラデーションやフレームを使って、QRコードをプロフェッショナルに仕上げられます。',
          },
          {
            title: 'カスタムロゴ対応:',
            text: 'ブランドロゴをアップロードすると、QRコード中央に自動で最適配置されます。さらに、30種類以上のロゴを収録した内蔵ライブラリから選択することもできます。',
          },
          {
            title: 'ライブプレビュー:',
            text: 'カスタマイズ中の変更はすべてライブプレビューパネルにリアルタイムで表示され、動的に反映されます。',
          },
          {
            title: 'スキャン指標:',
            text: '色選択時に、読み取りが難しくなる組み合わせを選ぶと適切な警告やインジケーターで案内します。',
          },
        ],
        formatHeaders: {
          srNo: '番号',
          formats: '形式',
          description: '説明',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: '可逆圧縮、透過対応' },
          { no: '2', format: 'JPG', description: '一般的で汎用的なファイル形式' },
          { no: '3', format: 'WEBP', description: '最新形式、品質と容量のバランスが良い' },
          { no: '4', format: 'SVG', description: '拡大縮小可能なベクター画像' },
          { no: '5', format: 'PDF', description: '印刷対応ドキュメント' },
        ],
      },
      card3: {
        title: '3. ステップバイステップガイド:',
        step1Intro: 'まず、作成したいQRコードのカテゴリを選択します。連絡先、地図、リンク、テキストなどの用途に対応しています。現在、当社のQRコードジェネレーターでは次のカテゴリを提供しています:',
        categories: ['リンク / URL', 'テキスト', 'WiFi', '連絡先', 'Gmail', 'Google Maps'],
        step2: 'カテゴリを選択したら、対応する入力ボックスに情報を貼り付けます。',
        step3Intro: '次に、Generate & Customize をクリックしてカスタマイズパネルを開きます。パネル内には次のサブナビゲーションオプションがあります:',
        options: [
          {
            title: 'スタイルと形状:',
            text: 'このセクションでは、モジュール形状を角丸、ドット、横バー、縦バー、小さな四角など、複数のスタイルに変更できます。',
          },
          {
            title: 'カラー:',
            text: 'このセクションでは背景色と前景色を自由に設定できます。グラデーションを有効にすると、内蔵ライブラリのグラデーションを適用したり、独自のグラデーションを簡単に作成したりできます。線形グラデーションの角度変更にも対応し、放射状グラデーションもサポートします。複数色を使ってよりプロらしい表現が可能です。',
          },
          {
            title: 'フレーム:',
            text: 'ここではQRコードに最適なフレームを選択できます。すべてのフレームはコードに自動でフィットします。内蔵ライブラリからフレームを選ぶだけです。',
          },
          {
            title: 'ロゴ:',
            text: 'フレーム選択後、QRコード中央に自動調整されるロゴを選択できます。ブランドの独自ロゴのアップロードにも対応しています。',
          },
          {
            title: 'テンプレート:',
            text: 'スタイル・形状・色・フレームを個別に選びたくない場合は、プリメイドテンプレートを適用できます。使いやすい複数のプレミアムテンプレートを永久無料で提供しています。',
          },
          {
            title: 'ファイル形式:',
            text: '最後に、QRコードをダウンロードするファイル形式を選択します。PNG、WEBP、SVG、PDFなどの一般的な形式に対応しています。',
          },
          {
            title: 'QRデータを編集:',
            text: '選択済みのカスタマイズを失うことなく、QRデータだけを編集することもできます。',
          },
        ],
        finalStep: '最後にダウンロードボタンをクリックするだけで、選択した形式とカスタマイズ内容そのままのQRコードを即時に無料でダウンロードできます。',
      },
      card4: {
        title: '4. メリット:',
        intro: 'QRコードは現実世界とデジタル体験をつなぎます。リンク、連絡先、位置情報を共有する最速の方法の一つです。QRコードをスキャンするだけで、情報に即座にアクセスできます。そのため、時間効率が高く実用性も高いことから、ビジネスやデジタル分野で非常に広く利用されています。',
        benefits: [
          {
            title: '長期利用:',
            text: 'QRコード自体に有効期限はなく、長期間利用できます。スキャンすると保存情報を即座に提供します。デジタル命令が固定的に埋め込まれているため、情報が自然に失われることはありません。',
          },
          {
            title: 'オフライン対応:',
            text: 'オフラインでもQRコードをスキャンできます。スマートフォンのカメラがQRパターンを読み取り、格納された情報を表示します。',
          },
          {
            title: 'ゼロコスト:',
            text: 'これらのコードはサーバーリダイレクトや追加リソースを必要としないため、永久に無料で利用できます。',
          },
        ],
      },
    },
  },
  qrScanner: {
    seo: {
      title: 'QRコードスキャナー — カメラや画像でQRコードをスキャン | photremium.com',
      desc: 'カメラや画像アップロードでQRコードを即座にスキャン。URL、テキスト、WiFi、連絡先などを検出。無料・高速・プライベート。',
      keywords: 'QRコードスキャナー, QRコードスキャン, QRリーダー',
    },
    title: 'QRコードスキャナー',
    desc: 'カメラでQRコードを即座にスキャンするか、画像をアップロード。高速・プライベート＆安全 — すべてブラウザで動作。',
    generateQrCode: 'QRコードを生成',
    scan: 'スキャン',
    cameraScanner: 'カメラスキャナー',
    uploadImage: '画像をアップロード',
    pointCamera: 'QRコードにカメラを向けてください',
    startCamera: 'カメラを起動',
    loading: '読み込み中…',
    dropQrImage: 'QRコード画像をここにドロップ',
    toScan: 'スキャンする',
    supportedFormats: 'JPG、PNG、GIF、WEBPに対応',
    ctrlVPaste: 'Ctrl+Vで貼り付け',
    scanFromGallery: 'ギャラリーからスキャン',
    instantScanning: '即座スキャン',
    instantScanningDesc: 'カメラまたはアップロード画像からのリアルタイムQRコード検出',
    private100: '100%プライベート',
    private100Desc: 'すべての処理はブラウザ内で行われます。何もアップロードされません',
    multiFormat: 'マルチフォーマット',
    multiFormatDesc: 'URL、テキスト、WiFi、連絡先、メール、電話など検出',
    accessingCamera: 'カメラにアクセス中…',
    cameraDenied: 'カメラアクセスが拒否されました。カメラの許可を与えて再試行してください。',
    noCamera: 'このデバイスにカメラが見つかりません。',
    cameraError: 'カメラにアクセスできませんでした。再試行してください。',
    videoError: '動画再生を開始できませんでした。',
    switchError: 'カメラを切り替えられませんでした。',
    tryAgain: '再試行',
    switchCamera: 'カメラを切り替え',
    stop: '停止',
    noQrFound: 'QRコードが見つかりません',
    couldNotRead: '画像を読み取れませんでした',
    scannerFailed: 'スキャナーの読み込みに失敗しました',
    noQrFoundDesc: '画像にQRコードが検出されませんでした。別の画像を試すかカメラスキャナーを使用してください。',
    qrScanned: 'QRコードをスキャンしました！',
    openLink: 'リンクを開く',
    copied: 'コピーしました！',
    copy: 'コピー',
    share: 'シェア',
    scanAgain: '再スキャン',
    network: 'ネットワーク',
    password: 'パスワード',
    security: 'セキュリティ',
    unknown: '不明',
    typeText: 'テキスト',
    typeUrl: 'URL',
    typeWifi: 'WiFiネットワーク',
    typeContact: '連絡先カード',
    typeEmail: 'メール',
    typePhone: '電話番号',
    typeSms: 'SMS',
    typeLocation: '場所',
    blog: {
      tocTitle: '目次',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. なぜQRコードスキャナーを使うのか？',
          paragraphs: [
            'QRコードスキャナーは、QRコードに保存された情報をデコードするモバイルカメラです。カメラをQRコードに向けるだけで、向きに関係なく特定パターンを読み取り、エラーを検出し、必要に応じて修正し、その情報を表示します。',
          ],
          listTitle: 'QRコードスキャナーの種類：',
          bullets: [
            'WebベースQRコードスキャナー：ブラウザ対応のオンラインスキャナーでQRコードを読み取れます。カメラ利用または画像アップロードで情報取得が可能です。自動リダイレクトや高度機能は https://photremium.com をご利用ください。',
            'モバイルカメラ：最近のスマホには標準カメラアプリにQRコードスキャン機能が搭載されている場合があります。カメラを向けるだけで情報を取得・デコードできます。',
            'アプリ：QRコード専用の読み取りアプリもあります。ただし、高度なリダイレクトやその他機能を使う場合は、こちらのリンクから無料でアプリを利用できます： https://photremium.com。',
            'ハードウェア機器：QRコード専用のハードウェア機器もあります。大型ショッピングモールのレジ処理などで広く使われています。',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. なぜ当社のQRコードスキャナーを選ぶのか？',
          paragraphs: [
            'デコード結果のコピーからリダイレクトまで、複数の高度機能を利用できます。さらに当社のQRコードスキャナーには次のような便利機能があります：',
          ],
          bullets: [
            '高速処理：当社のQRコードスキャナーはデコードが非常に高速です。QRコードを読み取るだけで、テキスト/リンクのコピー、リンク検出時のオープン、連絡先検出時の自動保存など高度な操作をすぐに利用できます。',
            'インストール不要：当社のQRコードスキャナーを使うために別アプリを入れる必要はありません。ブラウザから無料で利用できます。',
            'クロスプラットフォーム対応：どのデバイスでも利用できます。OSバージョンや追加要件を気にする必要はありません。幅広い環境で動作します。',
            '全フォーマット対応：プレーンテキスト、WiFi、URL、連絡先、Gmail、Googleマップなど、QRコードに保存可能なデータ形式を幅広くサポートしています。',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. ステップバイステップガイド：',
          steps: [
            {
              heading: '1. まず、QRコードをスキャンする方法を選択します。方法は次の2つです：',
              subSteps: [
                {
                  heading: 'i. カメラ方式',
                  paragraphs: [
                    'ノートPC、デスクトップPC、その他カメラ対応デバイスでも、端末カメラでQRコードをスキャンできます。「カメラ開始」ボタンを押すと許可ダイアログが表示されるので、このサイトのカメラ利用を許可してください。誤って拒否した場合やダイアログが出ない場合は、次の手順で手動許可できます：',
                  ],
                  notes: [
                    '➔ Chrome（Android / Desktop）の場合：',
                    '1. 右上の3点メニューをタップ',
                    '2. 設定を開く',
                    '3. （Androidはこの手順をスキップ）プライバシーとセキュリティ',
                    '4. サイトの設定を開く',
                    '5. 権限セクションでカメラを選択',
                    '6. サイトURL（https://photremium.com/qr-code-scanner）を探す',
                    '7. プルダウンでカメラを許可に設定する。',
                    '➔ Safari（iPhone / iOS）の場合：',
                    '1. アドレスバーのAAアイコンまたはWebsite Settingsをタップ。',
                    '2. Website Settingsを選択。',
                    '3. CameraをタップしてAllowを選択。',
                    '4. まだブロックされる場合：iPhone設定 > Safari > Camera でAskまたはAllowに設定。',
                  ],
                },
                {
                  heading: 'ii. ギャラリー方式',
                  paragraphs: [
                    'QRコード画像をアップロードして情報を取得できます。「ギャラリーからスキャン」ボタンを押すとファイル選択が開きます。QR画像を選択すると読み取りが開始されます。.jpg、.jpeg、.png、.gif、.webp、.svg、.avif、.heic、.heif、.jxl、.bmp、.ico、.tiff、.tif、.jfif、.jpe、.pjpeg、.pjp、.apng、.svgz、.xbm など幅広い画像形式に対応しています。',
                  ],
                },
              ],
            },
            {
              heading: '2. QRコードを選択すると、すべての情報が表示されます。内容をコピー、共有、リンク検出時のオープンが可能です。必要であれば再スキャンもできます。',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'QRコードスキャナーのメリット：.',
          paragraphs: [
            'QRコードスキャナーは、デジタル時代に多くのメリットをもたらします。支払い、認証、情報アクセスを簡単かつ高速にし、オフラインでも活用できます。',
          ],
          bullets: [
            '情報へ即時アクセス：QRコードを読み取ると、情報がミリ秒単位で表示されます。パターン解析、エラー検出、補正を高速で行い、非常に快適な体験を提供します。',
            'スムーズなコミュニケーション：銀行情報や製品情報など小さな情報を速く安全にやり取りする需要が高まっています。QRコードスキャナーはこの課題を解決します。支払いはQRコード読み取りで実行され、GoogleでもノートPCで新規アカウント作成時にQRでスマホ認証を行うケースがあります。',
            '電子チケット：バスターミナル、駅、空港で、長い列に並ばずチケット確認がしやすくなります。空港では複数のQRスキャナー設置により待機列を削減でき、人員負担の軽減やコスト削減にもつながります。',
            '製品認証：高級ブランドや先進ブランドは製品にQRコードを付与します。ユーザーはそれを読み取り、正規品かどうかを確認できます。',
          ],
        },
      ],
    },
  },
  faceBlur: {
    seo: {
      uploadTitle: '顔ぼかしツール — 画像の顔をオンラインでぼかす | photremium.com',
      uploadDesc: 'AI顔検出で画像の顔を自動的にぼかします。ぼかし強度・形状・絵文字オーバーレイを選択。100%無料・高速・プライベート。',
      uploadKeywords: '顔ぼかし, 顔を隠す, 顔検出, プライバシーツール',
      workspaceTitle: '顔ぼかしツール — photremium.com',
      workspaceDesc: '画像の顔を自動的にぼかします。100%無料・高速・プライベート。',
      workspaceKeywords: '顔ぼかし',
    },
    title: '顔ぼかし',
    desc: 'プライバシー保護のために画像の顔を自動検出してぼかします。ぼかし強度・形状を選択するか、楽しい絵文字で顔を覆います。100%クライアントサイド — 画像はデバイスから出ません。',
    toBlurFaces: '顔をぼかす',
    autoDetection: '自動検出',
    autoDetectionDesc: 'AI搭載顔検出がすべての顔を即座に見つけます',
    customBlur: 'カスタムぼかし',
    customBlurDesc: 'ぼかし強度・形状・スタイルを調整',
    private100: '100%プライベート',
    private100Desc: 'すべての処理はブラウザ内でローカルに行われます',
    blurTools: 'ぼかしツール',
    faces: '顔',
    faceDetection: '顔検出',
    detecting: '検出中...',
    autoDetectFaces: '顔を自動検出',
    exitManualMode: '手動モードを終了',
    manualSelect: '手動選択',
    nFaceRegions: '{n}個の顔領域が見つかりました',
    noFacesDetected: '顔が検出されませんでした — 手動モードを使用してください',
    manualHint: 'ぼかしたい部分の上に矩形を描くには、画像上をクリックしてドラッグします。',
    blurType: 'ぼかしタイプ',
    blur: 'ぼかし',
    emoji: '絵文字',
    blurIntensity: 'ぼかし強度',
    strength: '強さ',
    blurShape: 'ぼかし形状',
    rectangle: '四角形',
    ellipse: '円形',
    circle: '円',
    chooseEmoji: '絵文字を選択',
    blurRegionsN: 'ぼかし領域 ({n})',
    faceN: '顔 {n}',
    manualRegionN: '手動領域 {n}',
    manualN: '手動 {n}',
    clearAllRegions: 'すべての領域をクリア',
    processingDots: '処理中...',
    downloadBlurred: 'ぼかし画像をダウンロード',
    downloadNImages: '{n}枚の画像をダウンロード',
    downloadDialogTitle: 'すべての画像が編集されていません',
    downloadDialogText: '{total}枚中{edited}枚を編集しました。',
    downloadAll: 'すべてダウンロード',
    removeRegion: '領域を削除',
    region: '領域',
    notAllEdited: 'すべての画像が編集されていません',
    editedXofY: '{total}枚中{edited}枚を編集しました。',
    nextImage: '次の画像',
  },
  faqData: {
    imageConverter: [
      { q: '変換に対応した画像フォーマットは？', a: 'JPG、PNG、WEBP、SVG、GIF、BMP、ICO、TIFFに対応。ブラウザ内でいずれのフォーマット間でも即座に変換できます。' },
      { q: '変換中に画像品質に影響しますか？', a: 'PNGなどの可逆フォーマットでは問題ありません。JPGやWEBPなどの非可逆フォーマットでは最適なエンコード設定で最高の視覚品質を維持します。' },
      { q: 'ファイルサイズや数の制限はありますか？', a: '制限はありません。複数画像を一度にアップロードしてバッチ変換できます。すべてローカルで動作するため、速度はサーバーでなくデバイスに依存します。' },
      { q: 'データは安全ですか？画像はサーバーにアップロードされますか？', a: 'まったく問題ありません。すべての処理は100%ブラウザ内で行われます。画像はデバイスから出ることはなく、完全なプライバシーが保証されます。' },
      { q: '透明なPNG画像をJPGに変換できますか？', a: 'はい。JPGは透明をサポートしないため、透明部分はデフォルトで白背景で塗りつぶされます。' },
    ],
    imageCompressor: [
      { q: '画像を圧縮すると画質は下がりますか？', a: 'いいえ、推奨範囲を超えて圧縮しない限り、画質への影響はほとんどありません。品質はインジケーターで確認できます。 i. 圧縮 1%〜40%：緑表示「高品質」。 ii. 圧縮 41%〜60%：黄表示「標準品質」。この範囲が一般的に推奨です。 iii. 圧縮 61%〜100%：赤表示「低品質」の警告が出て、劣化が目立つ可能性があります。' },
      { q: '圧縮に対応している画像形式は何ですか？', a: '当ツールは次の形式に対応しています：\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '複数の画像を一度に圧縮できますか？', a: 'はい、可能です。端末の性能が十分であれば、複数画像（100枚以上も可）を同時に圧縮できます。圧縮は端末のリソースを使うため、高性能なPCやスマホほど高速です。低スペック端末でも分割して処理すれば問題なく、複数バッチでも無料で利用できます。' },
      { q: '画像をサーバーにアップロード・保存しますか？', a: 'いいえ。画像をサーバーへアップロードしたり保存したりすることはありません。すべての圧縮処理はブラウザー内でローカル実行され、画像は端末から外部へ送信されません。個人・機密画像も安心して処理できます。' },
      { q: 'この画像圧縮ツールは無料ですか？', a: 'はい、完全無料でずっと利用できます。料金請求は一切ありません。隠れた費用もありません。複数画像の圧縮を含むすべての機能を無料で使えます。' },
    ],
    cropImage: [
      { q: '画像をトリミングすると品質は下がりますか？', a: 'いいえ、画像をトリミングしても視覚的な品質にはまったく影響しません。トリミングは不要な部分を取り除くだけです。切り抜いて残す部分のピクセルを変更することはありません。したがって、ピクセルの劣化なく元の品質のまま画像をトリミングできます。' },
      { q: '画像トリミングツールで対応している画像形式は？', a: '当社の画像トリミングツールはほぼすべての画像形式に対応しているため、どの形式の画像でも選択できます。対応形式は以下のとおりです：\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '画像はあなたのサーバーにアップロードされますか？', a: 'いいえ、すべての処理はローカルブラウザ内で行われます。画像がデバイスの外に出ることはないため、当社サーバーへアップロードされることはありません。したがって、個人的な画像でもリスクなく当社の画像トリミングツールで処理できます。' },
      { q: '複数の画像を同時にトリミングできますか？', a: 'はい、システムが対応していれば複数画像（100枚以上でも）を同時にトリミングできます。画像トリミングはデバイスのリソースを使用するため、高性能なノートPC・PC・スマートフォンであれば多くの画像を一度に処理できます。低スペック端末の場合はバッチでのトリミングが可能で、同時に多くの画像を処理する場合でも本ツールは無料で利用できます。' },
      { q: 'この画像トリミングツールは無料ですか？', a: 'はい、この画像トリミングツールは永久に完全無料です。いつでもどこでも、どのデバイスからでも利用できます。すべてのデバイスに対応したレスポンシブデザインを利用でき、プレミアム機能への支払いを求められることはありません。すべての機能が隠れた料金なしで完全無料です。' },
    ],
    resizeImage: [
      { q: '複数の画像を同時にリサイズできますか？', a: 'はい、当社の画像リサイズツールでは複数画像を一度にリサイズできます。デバイスが対応する枚数をアップロードすると、AIエンジンがまとめて処理します。低スペック端末の場合は、ラグを避けるため複数バッチに分けて処理してください。画像のプライバシー保護のため、サーバーへ送信せず端末リソースで処理します。' },
      { q: 'この画像リサイズツールは無料ですか？', a: 'はい、このツールは永久無料です。プレミアム機能のための有料サブスクリプションを求められることはありません。リサイズ画像のダウンロードにも隠れた料金はありません。' },
      { q: '画像をリサイズすると品質は下がりますか？', a: '✅Decrease Size (downscale): 画像サイズを小さくしても視覚品質は下がりません。むしろリサイズ後の画像が元画像よりシャープに見えることがあります。したがって、元より小さい寸法へのリサイズで品質は低下しません。\n❌Increase Size (upscale): 元のサイズより拡大すると視覚品質に影響する場合があります。影響の大きさは拡大量に依存します。拡大するほど品質低下は大きくなります。' },
      { q: 'この画像リサイズツールは安全に使えますか？', a: 'はい、当社の画像リサイザーは安全です。特に個人・プライベート画像でも、すべてローカル処理されるため安心して使えます。処理中にデータがデバイス外へ出ることはありません。' },
      { q: 'どの画像フォーマットに対応していますか？', a: '当社の画像リサイズツールはすべての画像形式に対応しています。以下の形式の画像を選択できます：\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: '背景除去はどのように機能しますか？', a: 'ブラウザ内で直接動作する高度なAIモデルを使用して被写体を検出し、背景から分離して透明なPNGを生成します。' },
      { q: '複雑な背景でも機能しますか？', a: 'はい。AIモデルは様々なシーンに対応します。被写体と背景のコントラストが明確なほど最高の結果が得られます。' },
      { q: '複数の画像から背景を除去できますか？', a: 'はい。複数の画像をアップロードすると順次処理されます。すべての結果をZIPまたは個別でダウンロードできます。' },
      { q: '出力フォーマットは？', a: '常に透明な背景を持つPNGファイルで出力されます。' },
      { q: '画像はサーバーに送信されますか？', a: 'いいえ。AIモデルはWebAssemblyを使用してブラウザ内で完全に動作します。画像は常にデバイスに留まります。' },
    ],
    watermarkImage: [
      { q: '1. Photremium の透かしツールは無料ですか？', a: 'はい。photremium.com/watermark-image の透かしツールはアカウントやサブスクリプション不要で無料で利用できます。単一画像や複数画像のバッチ処理に対応し、ダウンロード制限や強制登録はありません。' },
      { q: '2. 同時に何枚の画像を処理できますか？', a: 'バッチ処理に対応しています。フォルダ丸ごとドラッグ&ドロップしたり、ファイルピッカーで複数選択したりできます。実際の制限はデバイスのメモリによります。' },
      { q: '3. 入力／出力でサポートされる画像形式は？', a: 'ブラウザの File API が扱える形式をサポートします：JPEG、JPG、PNG、WEBP、GIF（静的）、BMP、SVG。出力は元ファイルの形式を保持します。' },
      { q: '4. 解像度の異なる画像でも透かしは同じに見えますか？', a: 'はい。プロポーショナルな再配置エンジンが基準画像上の重心と相対位置を計算し、各ターゲット画像に同じ比率で適用します。' },
      { q: '5. ロゴや署名を透かしに使えますか？', a: 'もちろんです。右側の「Add Image」ボタンからPNG（透過）をアップロードすると透過を保ったまま透かしレイヤーとして使用できます。' },
      { q: '6. 透かしを半透明にするには？', a: 'キャンバス上で透かしレイヤーを選択し、不透明度スライダーで調整します。30〜50％が目立ちすぎない良い目安です。' },
      { q: '7. 1枚の画像に複数の透かしを追加できますか？', a: 'はい。レイヤーシステムは複数の透かしをサポートし、それぞれ個別に設定できます。' },
      { q: '8. タイリング機能とは何で、いつ使うべきですか？', a: 'タイリングは透かしをグリッド状に繰り返して画像全体を覆います。無断使用を防ぎたい場合に有効です。' },
      { q: '9. モバイルやタブレットで使えますか？', a: 'はい。画面幅が狭いときはレイアウトが縦並びに切り替わり、操作要素はタッチに最適化されます。' },
      { q: '10. 画像はプライベートですか？サーバーにアップロードされますか？', a: '画像は端末を離れません。すべての処理はブラウザ内で Canvas API を使って実行され、画像データのネットワーク送信は行われません。' },
    ],
    qrCodeGenerator: [
      { q: 'このQRコードは有効期限がありますか？', a: 'いいえ、これらのQRコードに有効期限はなく、長期間利用できます。QRコードは四角いセル内のビットとして固定情報を保存するため、保存された情報は変更や削除ができません。何年後でも任意のカメラでスキャンするだけで、コード内の情報にアクセスできます。' },
      { q: 'なぜ私のQRコードは読み取れないのですか？', a: 'QRコードが読み取れない主な理由は次のとおりです。i. コントラスト不足: 背景色と前景色が似すぎていると視認性が下がり、読み取りに失敗します。当ツールはカスタマイズ時に低コントラストなどの問題を警告します。ii. データ量が多すぎる: 長すぎるテキストを入れるとQRコードが複雑になり、読み取りが難しくなります。文字数バリデータが最適な長さを案内します。iii. 印刷がぼやけている: PNGやSVGなど高解像度形式でダウンロードしてください。これらは当ツールでサポートされています。' },
      { q: 'QRコードにロゴを追加できますか？', a: 'はい、可能です。独自ロゴをアップロードするか、内蔵ロゴライブラリから選択できます。選択したロゴはQRコード中央に自動で最適配置されます。' },
      { q: 'QRコードはどうやってスキャンできますか？', a: 'スマートフォンのカメラでQRコードをスキャンできます。リンクへの自動遷移やさらに高度な機能を使いたい場合は、https://photremium.com/qr-code-scanner の無料QRコードスキャナーをご利用ください。' },
      { q: '無料で何個のQRコードを作成できますか？', a: '無制限です！無料で複数のQRコードを作成できます。すべての機能、カスタマイズ、テンプレートは誰でも永久無料です。プレミアム機能を使うための契約は不要です。' },
      { q: 'QRコード作成にログイン/サインアップは必要ですか？', a: 'いいえ。テキストを入力してQRコードを生成し、カスタマイズ後にダウンロードするだけです。ログインやサインアップは不要で、すべての機能を完全無料で利用できます。' },
    ],
    qrCodeScanner: [
      { q: '保存画像やスクリーンショットからQRコードをスキャンできますか？', a: '**はい**、保存画像やスクリーンショットからQRコードをスキャンできます。当社のQRコードスキャナー https://photremium.com/qr-code-scanner では、ギャラリーからQRコードを読み取れます。画像を選ぶだけで、そのQRコードから復元された情報をすべて確認できます。' },
      { q: 'QRコードスキャナー用のアプリをインストールする必要はありますか？', a: '**いいえ**、当社のWebベースQRコードスキャナーはアプリのインストールなしで利用できます。どのデバイスでも無料で高度なQRスキャン機能を使えます。' },
      { q: 'スキャナーがQRコードを認識しないのはなぜですか？', a: '次のいずれかが原因でスキャンできない可能性があります： i. 光量不足：暗い場所ではスキャンしにくくなります。画面から読み取る場合はライトを点け、画面輝度を上げてください。 ii. 距離：適切でない距離でも失敗します。最適距離はおよそ10インチ（25cm）です。 iii. レンズ汚れ：カメラレンズが汚れていると読み取りに失敗します。スキャン前にレンズを清掃してください。『スキャナーに枠グリッドが見えますか？その中にQRコードを収めると正しく読み取れます。』' },
      { q: 'このツールは反転QRコードやカラフルなQRコードも読み取れますか？', a: '**はい**、色や向きに関係なく読み取り可能です。ただし背景色と前景色のコントラストが低い場合、スキャンが難しくなることがあります。' },
      { q: 'このツールは無料ですか？', a: '**はい**、このツールは完全無料です。QRコードを無制限に無料でスキャンできます。' },
    ],
    faceBlur: [
      { q: '顔検出はどのように機能しますか？', a: 'ブラウザ内で直接動作するAI搭載顔検出モデルを使用します。画像の顔を識別してぼかし効果を適用できます。' },
      { q: 'ぼかしする顔を選ぶことができますか？', a: 'はい。検出後、各顔領域がハイライトされ、どれをぼかすか選択してそれぞれのぼかし強度を調整できます。' },
      { q: 'どのようなぼかしスタイルがありますか？', a: 'ガウスぼかし、ピクセル化、または単色オーバーレイから選択できます。各効果の強度は完全に調整可能です。' },
      { q: '複数の画像の顔を一度にぼかすことができますか？', a: 'はい。複数の画像をアップロードし、ぼかし領域を設定して、すべての処理済み画像をZIPまたは個別でダウンロードできます。' },
      { q: 'リモートサーバーに写真が送信されますか？', a: 'いいえ。AIモデルはWebAssemblyを使用してブラウザで動作します。写真はサーバーにアップロードされることはありません。' },
    ],
    photoEditor: [
      { q: 'どのような編集機能がありますか？', a: '明度・コントラスト・彩度の調整、フィルター適用、テキスト・オーバーレイ・フレーム・ステッカーの追加など、すべてブラウザ内で行えます。' },
      { q: '元に戻す/やり直しはサポートされていますか？', a: 'はい。完全な元に戻す/やり直し履歴があるので、自由に実験して作業を失う心配はありません。' },
      { q: 'どのファイルフォーマットを編集・エクスポートできますか？', a: 'JPG、PNG、WEBPなどの一般的なフォーマットを編集できます。希望のフォーマットと品質でエクスポートできます。' },
      { q: 'エディタはモバイルで動作しますか？', a: 'はい。完全レスポンシブでタッチフレンドリーなため、スマートフォンやタブレットでも画像を編集できます。' },
      { q: '画像はサーバーに保存されますか？', a: 'いいえ。すべての編集はローカルに実行されます。画像はデバイスから出ることはありません。' },
    ],
  },
};

export default ja;
